/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Błąd wewnętrzny',
      not_allowed: 'Akcja niedozwolona',
      access_denied: 'Odmowa dostępu',
      validator_error: 'Błąd walidatora {details}',
      wrong_body: 'Nieprawidłowe dane',
      wrong_token: 'Nieprawidłowy token',
      missing_token: 'Brak tokena',
      exclusive_lock: 'Wyłączna blokada',
      access_denied_acl: 'Odmowa dostępu (ACL)',
      connection_timeout: 'Czas połączenia minął',
      login_required: 'Wymagane logowanie',
      not_found: 'Nie znaleziono',
      wrong_value: 'Nieprawidłowa wartość',
      token_expired: 'Token wygasł',
      service_not_available: 'Usługa niedostępna',
      twofa_required: 'Wymagane uwierzytelnienie 2FA',
      missing_login_token: 'Wymagane logowanie',
    },
    account: {
      banned: 'Konto zbanowane',
      wrong_login_or_password: 'Nieprawidłowy login lub hasło',
      wrong_login: 'Nieprawidłowy login',
      wrong_password: 'Nieprawidłowe hasło',
      blocked: 'Konto zablokowane',
      missing_email: 'Nieprzypisany adres email',
      same_password_used: 'Użyto tego samego hasła',
      apikey_not_created: 'Klucz API nie został utworzony',
      apikey_already_created: 'Klucz API jest już utworzony',
      twofa_not_created: '2FA nie został utworzony',
      twofa_already_created: '2FA jest już utworzone',
      deletion_already_started: 'Usuwanie konta już się rozpoczęło',
      wrong_twofa: 'Nieprawidłowy kod 2FA',
      external_withdraw_not_available: 'Wypłata zewnętrzna nie jest dostępna',
      twofa_limit: 'Limit 2FA',
      kyc_wrong_step: 'Nieprawidłowy krok KYC',
      not_exists: 'Nie istnieje',
      kyc_required: 'KYC wymagany',
      action_not_allowed: 'Akcja nidedozwolona',
      migration: 'Migracja',
      wrong_password_pattern: 'Hasło musi mieć od 8 do 64 znaków i co najmniej: wielką literę, małą litera, cyfrę, znak specjalny',
      deleted: 'Twoje konto BitSKins zostało trwale usunięte',
      same_email_used: 'Wpisany adres e-mail to ten sam email, którego używasz teraz. Jeśli chcesz go zmienić, użyj innego adresu.',
      report_failed: 'Wygenerowanie raportu nie powiodło się. Spróbuj ponownie.',
      forbidden_url_store: 'Adres URL sklepu zawiera zabronione słowa',
    },
    market: {
      not_enough_funds: 'Niewystarczająca ilość środków',
      missing_steam_token: 'Brak adresu url wymiany Steam',
      missing_steam_id: 'Brak Steam ID',
      wrong_item_status: 'Nieprawidłowy status przedmiotu',
      item_already_queued: 'Przedmiot jest już w kolejce',
      max_price_limit: 'Maksymalny limit ceny',
      item_not_available: 'Przedmiot niedostępny',
      steam_vac_ban: 'VAC ban Steam',
      steam_trade_ban: 'Ban wymiany Steam',
      steam_private_profile: 'Prywatny profil Steam',
      steam_private_inventory: 'Prywatny ekwipunek Steam',
      steam_tradehold: 'Wstrzymanie handlu Steam',
      cannot_check_tradeban: 'Nie możemy sprawdzić blokady wymiany',
      cannot_check_tradehold: 'Nie możemy sprawdzić wstrzymania handlu',
      wrong_steam_token: 'Nieprawidłowy adres url wymiany Steam',
      items_limit: 'Limit przedmiotów',
      instant_sell_disabled: 'Natychmiastowa sprzedaż wyłączona',
      plan_not_found: 'Nie znaleziono planu',
      price_too_low: 'Zbyt niska cena przedmiotu',
      no_items_found: 'Nie znaleziono przedmiotów',
      queue_full: 'Nasza kolejka wypłat jest obecnie pełna. Proszę spróbować ponowanie za kilka minut.',
      popular_methods: 'Popularne metody płatności',
      no_picture: 'Brak zdjęcia',
    },
    steam: {
      wrong_tradelink: 'Nieprawidłowy adres wymiany',
      private_inventory: 'Prywatny ekwipunek Steam',
      cannot_check_tradeban: 'Nie możemy sprawdzić blokady wymiany',
      cannot_check_tradehold: 'Nie możemy sprawdzić wstrzymania handlu',
      vac_ban: 'Blokada VAC',
      trade_ban: 'Blokada handlu',
      private_profile: 'Prywatny profil Steam',
      tradehold: 'Wstrzymanie handlu',
      wrong_token: 'Nieprawidłowy token',
      missing_token: 'Brak adresu url wymiany Steam',
      missing_steam_id: 'Brak Steam ID',
      community_ban: 'Ban społeczności',
      economy_ban: 'Ban ekonomii',
      platform_offline: 'Brak połączenia ze Steam, prawdopodobnie serwery są wyłączone. Prosimy spróbować ponownie później.',
      cannot_check_escrow: 'Nie można sprawdzić ograniczenia handlu (escrow)',
      escrow: 'Używasz mailowej wersji Steam Guard, która nie jest wystarczająca aby handlować z naszymi botami. Musisz aktywować mobilną wersję Steam Guard.',
      fresh_account: 'Musisz najpierw ustawić profil na platformie steam',
      important: 'Ważne',
      item_may_be_incorrect: 'Zdjęcie przedmiotu może być nieprawidłowe. Sprawdź przedmiot w grze przed zakupem!',
    },
    mutex: {
      long_lock: 'Długa blokada, spróbuj ponownie za {ttl} sekund',
      exclusive_lock: 'Wyłączna blokada',
    },
    api: {
      missing_apikey: 'Brak klucza API',
      missing_secret: 'Brak sekretu API',
      wrong_ip_address: 'Nieprawidłowy adres IP',
      private_ip_address: 'Prywatny adres IP',
      wrong_apikey: 'Nieprawidłowy klucz API',
    },
    record: {
      item_not_found: 'Nie znaleziono przedmiotu',
      item_not_owned: 'Nie jesteś właścicielem przedmiotu',
      own_item: 'Własny przedmiot',
      there_are_no_records: 'Brak rekordów do wyświetlenia',
      record_already_exists: 'Rekord już istnieje',
      record_not_exists: 'Rekord nie istnieje',
      already_exists: 'Już istnieje',
      not_exists: 'Nie istnieje',
      not_updated: 'Niezaktualizowany',
      forbidden: 'Zabroniony',
    },
    bot: {
      not_found: 'Nie znaleziono bota',
      not_available: 'Bot nie jest dostępny',
    },
    wallet: {
      cannot_transfer_money: 'Nie można przenieść środków',
      amount_negative: 'Kwota ujemna',
      amount_positive: 'Kwota dodatnia',
      card_scoring_too_low: 'Zbyt niska punktacja karty',
      not_enough_balance: 'Niewystarczająca ilość środków',
      kyc_window_limit: 'Limit okna KYC',
      service_window_limit: 'Limit okna serwisu',
      amount_limit: 'Limit kwotowy',
      wrong_wallet_address: 'Nieprawidłowy adres portfela',
      card_not_found: 'Nie znaleziono karty',
      cannot_process_transaction: 'Nie możemy przetworzyć twojej transakcji',
      only_past_months_accepted: 'Akceptowane są tylko ubiegłe miesiące',
      only_visa_allowed: 'Tylko karty VISA są dozwolone',
      you_cannot_complete_this_action: 'Nie możesz dokończyć tej akcji, ponieważ nie masz na koncie wystarczających środków.',
      you_need_to_deposit_at_least_x: 'Aby dokończyć tę akcję musisz wpłacić co najmniej {x}.',
      invalid_card_number: 'Nieprawidłowy numer karty',
    },
    gift_code: {
      not_found: 'Nie znaleziono kodu',
      already_used: 'Kod został już wykorzystany',
      own_code: 'To jest twój własny kod',
    },
    partner: {
      subaccount_not_enabled: 'Subkonto nie jest włączone',
      link_account_first: 'Najpierw połącz konto',
      account_already_linked: 'Konto jest już połączone',
      wrong_phrase: 'Nieprawidłowe wyrażenie',
      cannot_link_yourself: 'Nie możesz podłączyć własnego konta',
      account_already_exists: 'Konto już istnieje',
    },
    payment: {
      card_scoring: 'Scoring karty jest zbyt niski',
      payment_issue: 'Problem z płatnością',
    },
    auth: {
      failed_to_authenticate: 'Nie udało się uwierzytelnić',
      not_valid_identity: 'Nieprawidłowa tożsamość',
      authentication_failed: 'Uwierzytelnianie nie powiodło się',
    },
    social: {
      cannot_create_chat: 'Nie można utworzyć czatu',
      discord_not_found: 'Nie można znaleźć konta Discord',
    },
    support: {
      wrong_status: 'Nieprawidłowy status',
      ticket_limit: 'Osiągnięto limit zgłoszeń',
    },
    ipn: {
      verification_issue: 'Problem z weryfikacją',
    },
    affiliate: {
      same_code: 'Nowy kod powinien być inny',
      code_taken: 'Kod jest już zajęty',
      not_activated: 'Kod partnerski jest nieaktywowany',
      not_enough_balance: 'Niewystarczająca ilość środków',
    },
    bam: {
      bam_steam_015: 'Nasze boty utraciły sesję Steam. Prosimy spróbować ponownie za kilku minut.',
    },
  },
  error_fallback: 'Spróbuj ponownie później lub skontaktuj się z naszym wsparciem (Kod błędu: {code})',
  validator: {
    required: 'To pole jest wymagane.',
    string: 'To pole musi być ciągiem znaków.',
    stringEmpty: 'To pole nie może być puste.',
    stringMin: 'To pole musi mieć minimum {expected} znaków.',
    stringMax: 'To pole musi mieć maksimum {expected} znaków.',
    stringLength: 'To pole musi wynosić {expected} znaków.',
    stringPattern: 'To pole nie pasuje do wymaganego wzorca.',
    stringContains: 'To pole musi zawierać tekst „{expected}”.',
    stringEnum: 'To pole nie pasuje do żadnej z dozwolonych wartości.',
    stringNumeric: 'To pole musi być ciągiem liczbowym.',
    stringAlpha: 'To pole musi być ciągiem alfabetycznym.',
    stringAlphanum: 'To pole musi być ciągiem alfanumerycznym.',
    stringAlphadash: 'To pole musi być ciągiem znaków alfanumerycznych.',
    stringHex: 'To pole musi być ciągiem szesnastkowym.',
    stringSingleLine: 'To pole musi być ciągiem jednoliniowym.',
    stringBase64: 'To pole musi być ciągiem znaków base64.',
    number: 'To pole musi być liczbą.',
    numberMin: 'To pole musi być większe lub równe {expected}.',
    numberMax: 'To pole musi być mniejsze lub równe {expected}.',
    numberEqual: 'To pole musi być równe {expected}.',
    numberNotEqual: 'To pole nie może być równe {expected}.',
    numberInteger: 'To pole musi być liczbą całkowitą.',
    numberPositive: 'To pole musi być liczbą dodatnią.',
    numberNegative: 'To pole musi być liczbą ujemną.',
    array: 'To pole musi być tablicą.',
    arrayEmpty: 'To pole nie może być pustą tablicą.',
    arrayMin: 'To pole musi zawierać co najmniej {expected} elementów.',
    arrayMax: 'To pole musi zawierać elementy mniejsze lub równe {expected}.',
    arrayLength: 'To pole musi zawierać {expected} elementów.',
    arrayContains: 'To pole musi zawierać element „{expected}”.',
    arrayUnique: 'Wartość „{actual}” nie jest unikalna dla „{expected}”.',
    arrayEnum: 'Wartość „{actual}” nie pasuje do „{expected}”.',
    tuple: 'To pole musi być tablicą.',
    tupleEmpty: 'To pole nie może być pustą tablicą.',
    tupleLength: 'To pole musi zawierać {expected} elementów.',
    boolean: 'To pole musi być wartością logiczną.',
    currency: 'To pole musi zawierać prawidłowy format waluty',
    date: 'To pole musi być datą.',
    dateMin: 'To pole musi być większe lub równe {expected}.',
    dateMax: 'To pole musi być mniejsze lub równe {expected}.',
    enumValue: '„{expected}” nie pasuje do żadnej z dozwolonych wartości.',
    equalValue: 'Wartość tego pola musi być równa „{expected}”.',
    equalField: 'Wartość tego pola musi być równa wartości pola „{expected}”.',
    forbidden: 'To pole jest zabronione.',
    function: 'To pole musi być funkcją.',
    email: 'To pole musi zawierać prawidłowy adres e-mail.',
    emailEmpty: 'To pole nie może być puste.',
    emailMin: 'Długość tego pola musi mieć minimum {expected} znaków.',
    emailMax: 'Długość tego pola musi mieć maksimum {expected} znaków.',
    luhn: 'To pole musi zawierać prawidłową sumę kontrolną luhn.',
    mac: 'To pole musi zawierać prawidłowy adres MAC.',
    object: 'To pole musi być obiektem.',
    objectStrict: 'Obiekt zawiera niedozwolone klucze: „{actual}”.',
    objectMinProps: 'Obiekt musi zawierać co najmniej {expected} właściwości.',
    objectMaxProps: 'Obiekt musi zawierać co najwyżej {expected} właściwości.',
    url: 'To pole musi zawierać prawidłowy adres URL.',
    urlEmpty: 'To pole nie może być puste.',
    uuid: 'To pole musi zawierać prawidłowy UUID.',
    uuidVersion: 'To pole musi zawierać prawidłową wersję UUID.',
    classInstanceOf: 'To pole musi być instancją klasy „{expected}”.',
    objectID: 'To pole musi zawierać prawidłowy identyfikator obiektu.',
    record: 'To pole musi być obiektem.',
    stringPatternLatin: 'Proszę używać wyłącznie znaków łacińskich.',
  },
  body: {
    language: 'Język',
    currency: 'Waluta',
    currency_warning: 'Wszystkie operacje przetwarzane są w USD, waluty inne niż USD są przeliczane z USD i zmieniają jedynie sposób wizualizacji strony. Zmiany kursów walut mogą zwiększyć lub zmniejszyć twoje saldo.',
    choose_game: 'Wybierz grę',
    slider: {
      title_1: 'Ulepsz swój styl,',
      title_2: 'zdominuj grę',
      content: 'Odkryj najlepszą kolekcję skórek do podniesienia wrażenia z gry.',
      tile_1: 'Zmaksymalizuj swoje wrażenia z gry',
      tile_2: 'Uzyskaj najlepszy stosunek jakości do ceny',
      tile_3: 'Ciesz się bezpiecznym i bezproblemowym handlem',
    },
    footer_description: 'Misją BitSkins jest dostarczenie graczom platformy na której mogą sprzedawać przedmioty z popularnych gier, takich jak CS2, Dota2, Rust i TF2. Od momentu wejścia na rynek w 2015 roku z powodzeniem obsłużyliśmy milionych zadowolonych klientów, a nasz nacisk na bezpieczeństwo jest silniejszy niż kiedykolwiek.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Zasilane przez Steama. Niepowiązane z Valve Corp.',
    footer_email_support: 'Jeśli potrzebujesz wsparcia',
    footer_email_security: 'Jeśli chcesz zgłosić błędy',
    footer_email_partnership: 'Jeśli chcesz współpracować',
    market: 'Market',
    cart: 'Koszyk',
    cart_empty: 'Twój koszyk jest pusty',
    clear_cart: 'Wyczyść koszyk',
    checkout: 'Do kasy',
    in_the_cart: 'w koszyku',
    total: 'Łącznie',
    go_to_market: 'Przejdź do marketu',
    trustpilot_alt: 'Trustpilot z oceną {stars} i {reviews} recenzjami',
    reload_website: 'Odśwież stronę!',
    app_error: 'Błąd aplikacji: {error}',
    latest_articles: 'Ostatnie artykuły',
    steam_login: 'Login Steam',
  },
  home: {
    slider: {
      title_1: 'Ulepsz swój styl,',
      title_2: 'zdominuj grę',
      content: 'Odkryj najlepszą kolekcję skórek do podniesienia wrażenia z gry.',
      tile_1: 'Zmaksymalizuj swoje wrażenia z gry',
      tile_2: 'Uzyskaj najlepszy stosunek jakości do ceny',
      tile_3: 'Ciesz się bezpiecznym i bezproblemowym handlem',
    },
    trade: 'Handluj <span class="color-primary fw-m">skórkami</span> na bitskins',
  },
  maintenance: {
    we_will_be_back_soon: 'Wracamy niebawem',
    we_are_down_for_maintenance: 'Właśnie trwają prace konserwacyjne, ale wkrótce znowu będziemy online.',
    sorry_for_the_inconvenience: 'Przepraszamy za utrudnienia i do zobaczenia wkrótce!',
  },
  account: {
    add_funds: 'Dodaj środki',
    my_store: 'Mój sklep',
    selling: 'W sprzedaży',
    transactions: 'Transakcje',
    settings: 'Ustawienia',
    steam_settings: {
      open_settings: 'Otwórz ustawienia',
      open_steam_settings: 'Otwórz profil Steam',
      what_is_steam_guard: 'Czym jest Steam Guard?',
      inventory_status: 'Status ekwipunku',
      profile_status: 'Status profilu',
      change_trade_link: 'Zmień adres wymiany',
    },
    logout: 'Wyloguj',
    inventory: 'Ekwipunek',
    banned: {
      you_are_banned: 'Zostałeś <span class="text-cr">zbanowany</span>',
      your_account_has_been_banned: 'Twoje konto zostało zbanowane za naruszanie naszych',
      your_account_has_been_blocked: 'Twoje konto zostało zablokowane za naruszanie naszych',
      if_you_believe: 'Jeśli uważasz, że to pomyłka możesz się z nami skontaktować pod adresem <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: 'warunków użytkowania',
    },
    account_blocked: 'Konto <span class="text-cr">zablokowane</span>',
    api_access: 'Dostęp API',
    email: {
      required: 'Adres e-mail jest wymagany',
      required_for_this_payment_method: 'Nie możesz użyć tej metody płatności, ponieważ nie skonfigurowałeś adresu e-mail.',
      you_can_start_now: 'Możesz teraz rozpocząć proces konfiguracji.',
      setup: 'Skonfiguruj e-mail',
    },
    deleted: {
      title: 'Nie udało się zalogować',
      description: 'Twoje konto BitSkins zostało trwale usunięte',
    },
  },
  balance: {
    deposit_bonus_info: 'Dodajemy <strong class="text-cp">{percent}% bonusu do każdego depozytu</strong> pomiędzy {date_from}, a {date_to}.',
    deposit_bonus_amount: 'Otrzymasz bonus w wysokości <span class="text-cp">{bonus_amount}</span>, łącznie <span class="text-cp">{total_amount}</span>.',
    wallet: 'Portfel',
    withdraw: 'Wypłać',
    withdraw_to: 'Wypłać na',
    withdraw_again: 'Wypłać ponownie',
    withdrawable: 'Wypłacalne',
    total: 'Całkowite',
    balance: 'Saldo',
    deposits_and_sales: 'Wpłaty i sprzedaż',
    proceeds_from_sales: 'Wpływy ze sprzedaży',
    deposit: 'Wpłać',
    locked: 'Zamrożone',
    funds_locked: 'Środki zamrożone w transakcjach',
    pending_withdrawals: 'Wypłaty w toku',
    thank_you_for_your_payment: 'Dziękujemy za dokonanie płatności!',
    your_money_will_arrive_soon: 'Wkrótce otrzymasz swoje środki',
    your_payment_is_still_processing: 'Twoja płatność jest nadal przetwarzana, ale wkrótce środki powinny pojawić się na Twoim koncie.',
    in_case_you_do_not_receive: 'Jeśli nie otrzymasz środków w ciągu 15 minut, prosimy o kontakt z naszym wsparciem.',
    payment_pending: 'Płatność <span class="text-cbs">w toku</span>',
    payment_failed: 'Płatność się nie powiodła!',
    payment_canceled: 'Płatność <span class="text-cg">anulowana</span>',
    payment_has_been_cancelled: 'Płatność została anulowana zgodnie z żądaniem',
    unfortunately_we_were_unable: 'Niestety nie mogliśmy przetworzyć Twojej płatności.',
    please_try_again: 'Prosimy spróbować ponownie',
    if_the_problem_persists: 'Jeśli problem się powtórzy prosimy o kontakt z naszym wsparciem. Możesz także spróbować użyć innej metody płatności.',
    back_to_wallet: 'Powrót do portfela',
    total_description: 'Środki pochodzące z Twoich depozytów i sprzedaży.',
    withdrawable_description: 'Dochód ze sprzedaży. Środki te można wypłacić lub wydać na zakup przedmiotów.',
    locked_description: 'Tymczasowo zablokowane środki, których nie można wydać ani wypłacić. Powodem zablokowania środków są istniejące zlecenia kupna, kupowanie przedmiotów, etc...',
    deposit_with_cryptocurrencies: 'Wpłać za pomocą <span class="text-cp">kryptowalut:</span>',
    deposit_with_standard_payment_methods: 'Wpłać za pomocą <span class="text-cp">standardowych metod płatności:</span>',
    withdraw_with_cryptocurrencies: 'Wypłać za pomocą <span class="text-cp">kryptowalut:</span>',
    withdraw_with_standard_payment_methods: 'Wypłać za pomocą <span class="text-cp">standardowych metod płatności:</span>',
    your_amount: 'Twoja kwota',
    your_limit: 'Twój limit',
    your_limits: 'Twoje limity',
    increase_your_limits: 'Zwiększ swoje limity',
    payment_not_available_in_the_following_countries: 'Ta metoda płatności nie jest dostępna w następujących krajach:',
    the_price_is_updated_every_60_seconds: 'Cena jest aktualizowana co 60 sekund i jest to średnia cena pobierana z kilku giełd.',
    rate_includes_x_fee: 'Kurs zawiera {x}% opłaty.',
  },
  not_found: {
    title: 'Strona nie została znaleziona',
    message: 'Wygląda na to, że się zgubiłeś. Swoje wymarzone skiny<br> znajdziesz na stronie marketu.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Witamy</span> w BitSkins',
    sign_in: 'Zaloguj',
    sign_up: 'Zarejestruj',
    rules_text: 'Potwierdzam, że mam ukończone 18 lat lub więcej i akceptuję',
    sign_in_with_steam: 'Zaloguj przez Steam',
    sign_up_with_steam: 'Zarejestruj przez Steam',
    email: 'Email',
    password: 'Hasło',
    already_have_an_account: 'Masz już konto? Kliknij',
    to_login: 'aby się zalogować',
    to_login_via_email: 'aby zalogować się przez email',
    login_via_email: 'Zaloguj przez Email',
    log_in_using_your_email: 'Zaloguj się używając swojego adresu e-mail i hasła.',
    forgot_password: 'Zapomniałeś hasła?',
    login_via_steam: 'ZALOGUJ PRZEZ STEAM',
    register_first: 'Najpierw musisz się zarejestrować',
    passwords_not_migrated: 'Niestety, podczas ostatniej aktualizacji nie mogliśmy przenieść Twojego hasła, dlatego musisz je zresetować.',
  },
  common: {
    monthly: 'miesięcznie',
    click: 'Kliknij',
    claim: 'Odbierz',
    or: 'lub',
    and: 'oraz',
    confirm: 'Potwierdź',
    continue: 'Kontynuuj',
    cancel: 'Anuluj',
    enable: 'Włącz',
    enabled: 'włączone',
    disable: 'Wyłącz',
    disabled: 'wyłączone',
    download: 'Pobierz',
    twofa: 'Uwierzytelnienie dwustopniowe',
    terms_of_use: 'Warunki Użytkowania',
    privacy_policy: 'Polityka Prywatności',
    cookie_policy: 'Polityka Plików Cookie',
    about_us: 'O nas',
    changelog: 'Dziennik zmian',
    faq: 'FAQ',
    support: 'Wsparcie',
    affiliate: 'Program partnerski',
    blog: 'Blog',
    careers: 'Kariera',
    api: 'API',
    service_status: 'Status serwisu',
    loading: 'Ładowanie...',
    buy_skins: 'Kup skiny',
    sell_skins: 'Sprzedaj skiny',
    popular: 'Popularne',
    skin_categories: 'kategorie skinów',
    payments: 'Płatności',
    about_bitskins: 'Informacje o BitSkins',
    social_media: 'Media społecznościowe',
    follow_us: 'Obserwuj nas i dołącz do naszej społeczności!',
    enter_your_email: 'Wprowadź swój adres email',
    phone_number: 'Numer telefonu',
    verify: 'Zweryfikuj',
    add: 'Dodaj',
    update: 'Zaktualizuj',
    check_spam_folder: 'Jeśli nie możesz znaleźć wiadomości w swojej skrzynce odbiorczej, prosimy sprawdzić folder ze spamem.',
    here: 'tutaj',
    edit: 'edytuj',
    save: 'zapisz',
    copy: 'kopiuj',
    back: 'Powrót',
    back_to_login: 'Powrót do logowania',
    clear: 'Wyczyść',
    quantity: 'Ilość',
    name: 'Nazwa',
    bot_name: 'Nazwa bota',
    steam: 'Steam',
    steam_id: 'Steam ID',
    steam_group: 'Grupa Steam',
    browser: 'Przeglądarka',
    on: 'Włącz',
    off: 'Wyłącz',
    hidden: 'Ukryto',
    empty: 'Puste',
    expires_in: 'Wygasa za',
    member_since: 'Członek od',
    close: 'Zamknij',
    paint_seed_value: 'Ziarno farby: {value}',
    error: 'Błąd',
    retry: 'Spróbuj ponownie',
    no_options_available: 'Brak dostępnych opcji',
    search: 'Szukaj',
    any: 'Dowolny',
    min: 'Min',
    max: 'Maks',
    no_limit: 'Bez limitu',
    scroll_left: 'Przewiń w lewo',
    scroll_right: 'Przewiń w prawo',
    load: 'Załaduj',
    delete: 'Usuń',
    remove: 'Usuń',
    all: 'Wszystko',
    game: 'Gra',
    reset: 'Wyczyść',
    in: 'w',
    optional: '(opcjonalnie)',
    default: 'Domyślny',
    filter: 'Filtr',
    up_to: 'Do',
    similar: 'Podobne',
    important: 'Ważne',
    step: 'Krok',
    share_link: 'Udostępnij link',
    zoom: 'Zoom',
    found: 'Znaleziono',
    try_again: 'Spróbuj ponownie',
    of: 'z',
    timer: 'Zegar',
    add_new: 'Dodaj nową',
    and_more: 'I WIĘCEJ',
    check_status: 'Sprawdź status',
    resend_link: 'Ponownie wyślij link',
    back_to_home: 'Powrót do strony głównej',
    data_visible_only_to_logged_in_users: 'Te dane są widoczne tylko dla zalogowanych użytkowników',
    login: 'Zaloguj',
    level: 'Poziom',
    x_to_y: '{x} do {y}',
    minimum_x: 'Minimalnie {x}',
    maximum_x: 'Maksymalnie {x}',
    twofa_code: 'Kod 2FA',
    id: 'ID',
    position: 'Pozycja',
    amount: 'Kwota',
    progressive_sum: 'Suma progresywna',
    date: 'Data',
    active: 'Aktywne',
    yes: 'Tak',
    no: 'Nie',
  },
  notifications: {
    always: 'Zawsze',
    change: 'Zmień',
    setup: 'Skonfiguruj',
    disconnect: 'Odłącz',
    connect: 'Połącz',
    notifications: 'Powiadomienia',
    notifications_center: 'Centrum powiadomień',
    clear_all: 'Wyczyść wszystkie',
    notifications_channels: 'Kanały powiadomień',
    connected: 'Połączono',
    all_notifications: 'Wszystkie powiadomienia',
    sound: 'Dźwięk',
    volume_mute: 'Wyciszenie',
    volume_full: 'Maksymalna głośność',
    all_sounds: 'Wszystkie dźwięki:',
    off: 'Wyłączony',
    on: 'Włączony',
    steam_issues_title: 'Problemy ze Steamem',
    steam_issues_content: 'Steam doświadcza w tej chwili problemów, które mogą mieć wpływ na oferty wymiany. Może skutkować to tym, że oferty nie będą przetwarzane lub tworzone.',
    name: {
      account_new_login: 'Nowe logowanie do konta',
      inventory_sold: 'Sprzedanie przedmiotu',
      inventory_buyorder: 'Zrealizowanie zamówienia kupna',
      wallet_deposit_done: 'Potwierdzenie wpłaty',
      support_new_reply: 'Nowa odpwowiedź w centrum wsparcia',
      support_ticket_closed: 'Zamknięcie zgłoszenia w centrum wsparcia',
      inventory_bargain_received: 'Otrzymanie kontroferty',
      inventory_bought: 'Kupno przedmiotu',
    },
    redirect_to_discord: 'Zostaniesz przekierowany do Discord',
    discord_connection_revoked: 'Połączenie z Discord usunięte',
    telegram_connection_revoked: 'Połączenie z Telegram usunięte',
  },
  announcement: {
    title: 'Informacja',
    text: 'Nasza pierwsza w historii mapa CS2 jest już dostępna: <a href="https://steamcommunity.com/sharedfiles/filedetails/?id=3071733061" rel="nofollow noopener noreferrer" target="_blank">Inspect Skins</a> (Dostępna w warsztacie Steam)',
  },
  market: {
    any_stickers: 'Z naklejkami',
    this_item: '(ten przedmiot)',
    no_items_found: {
      no_items_found: 'Nie znaleziono przedmiotów',
      no_items_found_span: '<span>Nie znaleziono</span> przedmiotów',
      we_could_not_find_any_offers: 'Nie znaleźliśmy żadnych ofert',
      for: 'dla',
      this_can_be_due_to_applied_filters: 'Może to być spowodowane zastosowanymi filtrami. Możesz wyczyścić wszystkie filtry, klikając przycisk poniżej',
    },
    sell: 'Sprzedaj',
    skin: 'Skin',
    items: 'przedmiotów',
    items_v2: 'przedmioty',
    buy_orders: 'Zlecenia kupna',
    search_for: 'Wyszukaj przedmioty {game}',
    search_for_items: 'Wyszukaj przedmioty',
    reload: 'Przeładuj',
    item_name: 'Nazwa przedmiotu',
    enter_item_name: 'Wprowadź nazwę przedmiotu',
    price: 'Cena',
    reset: 'Wyczyść',
    all_items: 'Wszystkie przedmioty',
    sort: 'Sortowanie',
    add_sort: 'Dodaj sortowanie',
    steam_price: 'Cena Steam',
    reference_price: 'Cena referencyjna',
    steam_inventory: 'Ekwipunek Steam',
    your_steam_inventory: 'Twój ekwipunek Steam',
    bitskins_inventory: 'Ekwipunek BitSkins',
    your_bs_inventory: 'Twój ekwipunek BitSkins {extra}',
    refresh: 'Odśwież',
    learn_how_to_sell: 'Zobacz jak sprzedawać',
    select_1_by_1: 'Zaznacz pojedynczo',
    select_all: 'Zaznacz wszystkie',
    selected_items: 'Wybrane przedmioty',
    items_amount: '{count} przedmiot | {count} przedmiotów',
    offers: 'ofert',
    favorites: 'Ulubione',
    last: 'Ostatnio',
    viewed: 'oglądane',
    same_price: {
      same_price_for: 'Ta sama cena dla',
      all_items: 'wszystkich przedmiotów',
    },
    save_all: 'Zapisz wszystkie',
    trade_hold: {
      name: 'Wstrzymanie handlu',
      between: 'Zablokowane od {min} do {max} dni',
      less: 'Zablokowane na mniej niż {value} dni',
      any: 'Wszelkie wstrzymanie handlu',
      none: 'Brak',
      tradable: 'Zbywalne',
      withdrawable_in_days_hours: 'Dostępny za {days} dni, {hours} godzin',
      withdrawable_in_hours_minutes: 'Dostępny za {hours} godzin, {minutes} minut',
    },
    filter: {
      type: 'Rodzaj',
      quality: 'Jakość',
      exterior: 'Wygląd',
      category: 'Kategoria',
      collection: 'Kolekcja',
      color: 'Kolor',
      family: 'Rodzina skinów',
      phase: 'Faza',
      rarity: 'Rzadkość',
      grade: 'Jakość',
      killstreak: 'Seria zabójstw',
      effect: 'Efekt',
      hero: 'Bohater',
      nametag: 'Tabliczka z nazwą',
      hightier: 'Wyższa półka',
      stickers: 'Naklejki',
      gloves: 'Rękawice',
      knives: 'Noże',
      slot: 'Pozycja {value}',
      paint_seed: 'Ziarno farby',
      paint_index: 'Indeks farby',
      sticker_counter: 'Ilość naklejek',
      float_value: 'Zużycie',
      active: '{value} aktywne',
      by_slot_position: 'Według pozycji slotu',
      filter_name: 'Nazwa filtra',
      you_can_have: 'Możesz mieć',
      filters_saved: 'zapisane filtry.',
      choose_stickers: 'Wybierz naklejki',
      no_stickers_found: 'Nie znaleziono naklejek',
      basic_filters: 'Podstawowe Filtry',
      advanced_filters: 'Zaawansowane Filtry',
      clear_all_filters: 'Wyczyść filtry',
      save_filters: 'Zapisz filtry',
      my_filters: 'Moje filtry',
      filters_are_not_available_on_this_page: 'Filtry nie są dostępne na tej stronie',
      status: 'Status',
      date_from: 'Data od',
      date_to: 'Data do',
      amount_from: 'Kwota od',
      amount_to: 'Kwota do',
      amount: 'Kwota',
      price: 'Cena',
      price_from: 'Cena od',
      price_to: 'Cena do',
      service: 'Usługa',
      item: 'Nazwa przedmiotu',
      game: 'Gra',
      only: 'Tylko',
      pattern: 'Wzór',
      back_to_main_list: 'Powrót do głównej listy',
      container: 'Pojemnik',
    },
    filter_value: {
      normal: 'Normalny',
      souvenir: 'Pamiątka',
      factory_new: 'Prosto z fabryki',
      minimal_wear: 'Lekkie zużycie',
      field_tested: 'Po testach bojowych',
      well_worn: 'Mocne zużycie',
      battle_scarred: 'Po ciężkich walkach',
      not_painted: 'Bez farby',
    },
    loading_item: 'Ładowanie przedmiotu',
    bestseller: 'Bestseller',
    this_is_your_item: 'To jest twój przedmiot',
    action: {
      right_click_screenshot: 'Kliknij prawym przyciskiem myszy, aby wyświetlić podgląd',
      screenshot: 'Zrzut ekranu',
      screenshot_tooltip_title: '<span class="tooltip-screenshot-title">Obecnie jesteśmy w fazie beta screenshotów CS2</span>',
      screenshot_tooltip_content: '<span class="tooltip-screenshot-content">Obecnie jesteśmy w fazie beta screenshotów CS2 i mogło zdarzyć się tak, że nie wszystkie screenshoty zostały wygenerowane poprawnie. Jeśli ten screenshot nie został wygenerowany poprawnie, możesz to zgłosić otwierając zgłoszenie w naszym centrum wsprarcia. Dołożymy wszelkich starań, aby jak najszybciej wygenerować jego poprawną wersję. Zgłoszenie możesz utworzyć klikając w ikonę.</span>',
      inspect: 'Sprawdź w grze',
      view_at_steam: 'Zobacz na Steam',
      view_at_steam_tooltip: 'Podgląd na Steam dostępny dnia {when}',
      check_on_steam_market: 'Sprawdź na markecie Steam',
      share: 'Udostępnij',
      sell_instantly: 'Sprzedaj natychmiast',
      buy: 'Kup',
      remove_from_sale: 'Wycofaj ze sprzedaży',
      check_on_market: 'Sprawdź na markecie',
      item_page: 'Strona przedmiotu',
      bulk_buy: 'Zakup hurtowy',
      add_to_favorites: 'Dodaj do ulubionych',
      remove_from_favorites: 'Usuń z ulubionych',
      buy_now: 'Kup teraz',
      bump: 'Podbij',
      sticker: 'Przedmioty z tą naklejką',
    },
    bump_minimum: 'Podbijanie jest dostępne tylko przedmiotów wartych więcej niż {amount}',
    your_price: 'Twoja cena',
    cart: {
      add_to_cart: 'Dodaj do koszyka',
      remove_from_cart: 'Usuń z koszyka',
      add_stickers_to_cart: 'Dodaj naklejki do koszyka',
      remove: 'Usuń',
      in_cart: 'W koszyku',
      clear_cart_warning: 'Czy na pewno chcesz usunąć wszystkie przedmioty z koszyka? <br> Tej akcji nie można cofnąć.',
    },
    details: 'Szczegóły',
    tags: 'Tagi',
    do_you_want_rename: 'Chcesz zmienić nazwę przedmiotu?',
    currently_not_available: 'Obecnie niedostępne',
    nametag: 'Tabliczka z nazwą',
    sales: 'Sprzedaż',
    private_offer: 'Prywatna oferta',
    public_offer: 'Publiczna ofera',
    offer_visible_only_to_people_with_link: 'Ta oferta jest widoczna tylko dla osób które mają do niej link',
    checkout: {
      if_any: 'Jeśli jakieś przedmioty nie są już dostępne wówczas nie zostaną uwzględnione w twoim zamówieniu.',
      remove_all_items: 'Usuń wszystkie',
      order_summary: 'Podsumowanie zamówienia',
      you_will_save: 'Zaoszczędzisz',
      i_have_read: 'Zapoznałem/am się i zgadzam się z warunkami użytkowania z usługi i polityką prywatności i rozumiem, że wszystkie zakupy są ostateczne i nie podlegają zwrotowi.',
      terms_and_policy: 'Przeczytałem/am i akceptuję <a href="https://bitskins.com/terms-of-use" class="link-primary-white" target="_blank">Warunki Użytkowania</a> oraz <a href="https://bitskins.com/privacy-policy" class="link-primary-white" target="_blank">Politykę Prywatności</a> i rozumiem, że wszystkie zakupy są ostateczne i nie podlegają zwrotowi.',
      confirm_checkout: 'Potwiedź zakup',
      you_need_to_deposit_at_least_x: 'Aby kupić przedmioty z koszyka musisz wpłacić co najmniej {amount}.',
      you_cannot_complete: 'Nie możesz dokończyć zamówienia, ponieważ nie masz wystarczającej ilości środków na swoim koncie. Aby zakupić przedmioty z koszyka musisz wpłacić co najmniej {amount}.',
      these_items_will_be_removed: 'Te przedmioty zostaną usunięte z listy po dokonaniu zakupu.',
      this_item_will_not_be_included: 'Ten przedmiot nie zostanie uwzględniony w  twoim zamówieniu',
      need_tos_accept: 'Musisz zaakceptować Warunki Użytkowania i Politykę Prywatności',
      no_items_selected: 'Nie wybrano żadnych przedmiotów',
      cannot_paid_by_card: 'Twoje zamówienie nie może zostać opłacone kartą',
      deposit_exceeded: 'Maksymalna kwota wpłaty kartą wynosi {limit}. Pozostała kwota potrzebna do zrealizowania zamówienia przekracza tę kwotę.',
      kyc_exceed: 'Aby zrealizować transakcję powyżej limitu KYC, <a href="https://bitskins.com/kyc/" class="text-cy-secondary" rel="nofollow noopener noreferrer" target="_blank">kliknij tutaj</a>, aby przejść weryfikację. Możesz również użyć środków z portfela lub innych dostępnych metod płatności.',
      add_new_card: 'Dodaj nową kartę',
      edit_card: 'Edytuj kartę',
      amount: 'Kwota',
      available_balance: 'Dostępne środki',
      card_duplicate: 'Karta o numerze {number} już istnieje',
      low_deposit_header: 'Kwota zamówinia jest za niska',
      low_deposit_content: 'Minimalna wartość zamówienia wynosi {min}, dlatego nie może zostać zrealizowane. Aby sfinalizować zamówienie, musisz dodać więcej przedmiotów na łączną kwotę {rest} lub zapłacić bezpośrednio z portfela.',
      low_deposit_content_short: 'Ten przedmiot kosztuje mniej niż {min}, dlatego nie można za niego zapłacić kartą.',
      low_deposit_link: 'Dodaj nowe itemy',
      pay_with_card: 'zapłać kartą',
      remaining_amount: '(pozostałą kwotę)',
      max_three_banks: 'Możesz mieć maksymalnie trzy karty przypisane do konta.',
      banks: 'Visa, Mastercard lub Maestro',
      credit_card_counter: 'zapłać kartą ({count}/3)',
      select_card: 'Wybierz kartę',
      blocked_card: 'NIEDOSTĘPNE: min {min}',
      change_price_before_update: 'Zmień cenę przed aktualizacją',
    },
    deposit_status: {
      available: 'Dostępny',
      missing: 'Brakujący',
      not_accepting: 'Nie akceptuję',
      wrong_price: 'Nieprawidłowa cena',
      already_queue: 'Już w kolejce',
      locked: 'Zablokowany',
    },
    withdraw_progress: {
      status: 'Status wypłaty',
      selected: 'Wybrany',
      waiting: 'Oczekiwanie',
      in_queue: 'W kolejce',
      trade_link: 'Adres wymiany',
      done: 'Wypłacono',
      error: 'Błąd',
      failed: 'Nieudana',
      pending: 'W toku',
    },
    trade_state: {
      Invalid: 'Nieważny',
      Active: 'Aktywny',
      Accepted: 'Zaakceptowany',
      Countered: 'Skontrowany',
      Expired: 'Wygasły',
      Canceled: 'Anulowany',
      Declined: 'Odrzucony',
      InvalidItems: 'Nieprawidłowe przedmioty',
      CreatedNeedsConfirmation: 'Utworzony, wymaga potwierdzenia',
      CanceledBySecondFactor: 'Anulowany przez drugi czynnik',
      InEscrow: 'Wstrzymany',
    },
    trade_type: {
      deposit: 'Depozyt',
      withdraw: 'Wypłata',
      bidirectional: 'Obustronny',
    },
    inventory: {
      history: 'Historia',
      active_trades: 'Aktywne oferty',
      loading_your_inventory: 'Ładowanie Twojego ekwipuneku',
      lower_sale_fee: '{value}% niższa opłata za sprzedaży',
      group_diff_price: 'Nie wszystkie przedmioty w grupie mają tę samą cenę',
      group_diff_delist: 'Nie wszystkie przedmioty w grupie są oznaczone do usunięcia',
      delist: 'Wycofaj',
      this_may_take_a_while: 'To może chwilę zająć',
      relist_items: 'Wystaw ponownie przedmioty',
      cancel_relisting: 'Anuluj ponowne wystawianie',
      cancel_withdrawal: 'Anuluj wypłatę',
      withdraw_items: 'Wypłać przedmioty',
      cancel_editing: 'Anuluj edycję',
      edit_items: 'Edytuj przedmioty',
      sell_items: 'Sprzedaj przedmioty',
      steam_offers: 'Oferty Steam',
      clear_withdraw_items: 'Wyczyść przedmioty',
      loading_inventory: 'Ładowanie ekwipunku',
      update_x_items: 'Zaktualizuj {amount}',
      delist_x_items: 'Wycofaj {amount}',
      fee_for_this_item: 'Opłata za sprzedaż tego przedmiotu wynosi tylko {value}%',
    },
    message: {
      failed_to_create_trade_offer: 'Nie udało się utworzyć oferty wymiany',
      offer: 'Oferta {hash}',
      offer_failed: 'Oferta nie powiodła się (ze statusem {state})',
      offer_confirmed: 'Twoja oferta została potwierdzona i pomyślnie wystawiłeś swoje przedmioty na sprzedaż',
      offer_sent: 'Twoja oferta wymiany została wysłana',
      open_trade: 'Otwórz ofertę',
      withdraw: 'Oferta wypłaty {hash}',
      withdraw_confirmed: 'Twoja wypłata została zaakceptowana',
      offer_preparing: 'Twoja transakcja jest przygotowywana. Wkrótce prześlemy ofertę',
      offer_active: 'Twoja oferta jest gotowa. Zaakceptuj tutaj',
      offer_needs_confirmation: 'Potwierdź ofertę w aplikacji mobilnej',
    },
    deposit_type: {
      public: 'Publiczny',
      public_description: 'Twoje przedmioty będą widoczne dla wszystkich użytkowników BitSkins. Jest to najbardziej popularna opcja sprzedaży.',
      private: 'Prywatny',
      private_description: 'Twoje przedmioty będą widoczne tylko dla osób, które będą miały do nich link. Prywatna sprzedaż jest o 50% tańsza od standardowej sprzedaży.',
      instant_sell: 'Szybka sprzedaż',
      instant_description: 'Po wysłaniu przedmiotów do naszego bota pieniądze zostaną natychmiast zaksięgowane na twoim koncie.',
    },
    click_to_open: 'Kliknij, aby otworzyć link w nowej karcie',
    no_active_trades: 'Brak aktywnych wymian',
    go_to_all_trades: 'Przejdź do wszystkich wymian',
    update_trade_link: 'Zaktualizuj adres wymiany',
    withdraw: 'Wypłata',
    lowest_price: 'Najniższa cena',
    highest_price: 'Najwyższa cena',
    no_filters_available: 'Brak dostępnych filtrów',
    select_a_hero: 'Wybierz bohatera:',
    view_all_items: 'Wyświetl wszystkie przedmioty',
    stattrak: 'StatTrak™',
    item_not_available: 'Ten przedmiot nie jest już dostępny',
    out_of_stock: 'Brak na stanie',
    find_similar_item: 'Znajdź podobny przedmiot',
    find_similar_items: 'Znajdź podobne przedmioty',
    sell_for: 'Sprzedaj za',
    recommended: 'Polecane',
    price_discounted: 'Obniżona cena',
    price_average: 'Średnia cena (polecana)',
    price_expensive: 'Wysoka cena',
    sticker: 'naklejka',
    more: 'Więcej',
    recent: 'Ostatni',
    item_not_found: 'Nie znaleziono przedmiotu',
    for: 'za',
    you_will_pay: 'Zapłacisz',
    fade: 'Gradient: {value}%',
    see_all_items: 'Zobacz wszystkie {amount} przedmiotów',
    it_my_take_a_while: 'To może chwilę zająć',
    no_transactions_found: 'Nie znaleziono transakcji',
    item: 'Przedmiot',
    edit: 'Edytuj',
    add_items_to_edit: 'Dodaj przedmioty do edycji',
    add_items_to_delist: 'Dodaj przedmioty do wycofania',
    add_items_to_sale: 'Dodaj przedmioty do sprzedaży',
    add_items_to_withdraw: 'Dodaj przedmioty do wypłaty',
    group_by_name: 'Grupuj według nazwy',
    select_items_from_your_inventory: 'Wybierz przedmioty ze swojego ekwipunku',
    earnings: 'Zyski',
    total_fee: 'Całkowita opłata',
    total_amount: 'Całkowita kwota',
    confirm_purchase: 'Potwierdź <span class="text-cp">zakup</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">Dziękujemy</span> za zakupy!',
    you_have_purchased_x_items_for: 'Kupiłeś {x} przedmiotów za',
    you_have_purchased_x_for: 'Kupiłeś <span class="text-cp">{x}</span> za',
    total: 'Całkowity',
    you_saved: 'Zaoszczędziłeś',
    see_your_inventory: 'Zobacz swój ekwipunek',
    you_bought: 'Kupiłeś',
    order_details: 'Szczegóły zamówienia',
    items_not_available: 'Niestety niektóre pozycje z Twojego koszyka są niedostępne, dlatego nie możesz ich kupić. Poniżej znajdziesz listę tych przedmiotów.',
    total_price: 'Cena całkowita',
    withdraw_all_items: 'Wypłać wszystkie przedmioty',
    private_listing: 'Prywatna oferta {extra}',
    public_listing: 'Publiczna oferta {extra}',
    instant_sale_price: 'Cena natychmiastowej sprzedaży',
    not_accepted: 'Nie akceptowany',
    not_available: 'Niedostępne',
    no_sales_data: 'Brak danych o sprzedaży',
    create_buy_order: 'Utwórz zlecenie kupna',
    active_buy_orders: 'Twoje aktywne zlecenia kupna',
    buy_orders_history: 'Historia zleceń kupna',
    market_buy_orders: 'Marketowe zlecenia kupna',
    recent_sales: 'Ostatnio sprzedane',
    selling_price: 'Kwota sprzedaży',
    sales_chart: 'Wykres sprzedaży',
    sales_history_will_be_available_soon: 'Historia sprzedaży BitSkins i Steam będą dostępne wkrótce',
    souvenir: 'Pamiątka',
    under: 'Poniżej {amount}',
    above: 'Powyżej {amount}',
    amount_to_amount: 'od {amount1} do {amount2}',
    discount: 'Zniżka',
    value_off_or_more: '{value}% zniżki lub więcej',
    removed_items: 'Usunięte przedmioty',
    restore_all_items: 'Przywróć wszystkie przedmioty',
    add_x_items_to_sale: 'Dodaj {amount} do sprzedaży',
    add_x_items_to_withdraw: 'Dodaj {amount} do wypłaty',
    sell_x_items: 'Sprzedaj {amount} przedmiotów',
    withdraw_x_items: 'Wypłać {amount} przedmiotów',
    first_you_need_to_select_an_item: 'Najpierw musisz wybrać przedmiot.',
    cheapest_price_on_bitskins: 'Najniższa cena na BitSkins:',
    final_price: 'Cena finalna:',
    check_quantity: 'Sprawdź ilość',
    cancel_selected_orders: 'Anuluj wybrane zamówienia',
    cancel_all_orders: 'Anuluj wszystkie zamówienia',
    community_rating: 'Ocena społeczności:',
    rating: 'Ocena',
    votes: 'głosów',
    open_image: 'Otwórz obrazek',
    cheaper_than_steam_by_x: 'Taniej niż na Steam o {x}%',
    cheaper_than_reference_by_x: 'Taniej niż cena referencyjna o {x}%',
    there_are_other_items_you_may_like: '<span>Inne przedmioty</span>, które mogą Ci się spodobać...',
    available_variants: 'Dostępne warianty',
    only_tradable_items: 'Tylko zbywalne',
    not_accepting: 'Nie akceptuję',
    private_offers: 'Oferty prywatne',
    private_offers_description: 'Masz {counter} ofert prywatnych. Możesz je znaleźć',
    picture: {
      playside: 'Przód',
      backside: 'Tył',
      steam: 'Obrazek z marketu Steam',
      top: 'Góra',
    },
    search_for_stickers: 'Szukaj naklejek',
    item_status: 'Stan przedmiotu',
    max_items_selected: 'Nie możesz wybrać więcej niż {limit} przedmiotów',
    queued: 'Oczekujące',
    queued_description: 'Tutaj znajdziesz przedmioty, które oczekują na wypłatę lub wpłatę.',
    withdrawn: 'Wypłacone',
    withdrawn_description: 'Tutaj znajdziesz wypłacone przedmioty.',
    issues: 'Problemy',
    issues_description: 'Tutaj znajdziesz przedmioty, z którymi mamy problemy. Obecnie pracujemy nad rozwiązaniem tych problemów.',
    withdrawal_batch_info: 'Proszę pamiętaj, że oferty wymiany wypłat wysyłami partiami co kilka minut.',
    maximum_price: 'Maksymalna cena',
    minimum_price: 'Minimalna cena',
    average_price: 'Średnia cena',
    amount_sold: 'Sprzedana ilość',
    item_withdrawn: 'Ten przedmiot został wypłacony',
    go_to_withdrawn: 'Przejdź do wypłaconych przedmiotów',
    item_issue: 'Mamy problem z tym przedmiotem',
    item_in_deposit_queue: 'Ten przedmiot znajduje się w kolejce depozytów',
    item_in_withdraw_queue: 'Ten przedmiot znajduje się w kolejce do wypłaty',
    go_to_queued: 'Przejdź do oczekujących przedmiotów',
    item_in_bitskins_inventory: 'Ten przedmiot znajduje się w twoim ekwipunku BitSkins',
    go_to_inventory: 'Przejdź do ekwipinku',
    go_to_issue: 'Przejdź do problemów',
    item_removed_from_sale: 'Przedmiot wycofany ze sprzedaży',
    price_updated: 'Cena zaktualizowana',
    game_not_found: 'Gra nie znaleziona',
    game_not_available: 'Gra obecnie niedostępna',
    buy_orders_not_available: 'Zamówienia kupna są obecnie niedostępne',
    add_x_items_to_edit: 'Dodaj {amount} do edycji',
    set_price: 'Ustaw cenę',
    non_scraped_only: 'Tylko nie zdrapane',
    confirm_price_change: 'Potwierdź zmianę ceny',
    are_you_sure_to_change_price: 'Jesteś pewien, że chcesz zmienić cenę na: <span class="text-cp fw-sb">{price}</span>?',
    no_trade_hold: 'Brak wstrzymania handlu',
    show_item_menu: 'Menu przedmiotów zawsze widoczne',
    show_snowfall: 'Animacja śniegu',
    popular_methods: 'Popularne mteody płatności',
    see_all: 'Sprawdź',
    item_bought: 'Przedmiot został kupiony',
    sticker_suggested_price: 'Sugerowana cena: {amount}',
    sticker_slot: 'Pozycja {slot}',
    sticker_wear_not_scratched: 'Zużycie: 100% (brak zużycia)',
    sticker_wear_full_scratched: 'Zużycie: 0% (prawie całkowicie zużyte)',
    sticker_wear: 'Zużycie: {wear}%',
    cart_cant_add_own_item: 'Nie możesz dodać własnego przedmiotu do koszyka',
    price_required: 'Musisz wypełnić cenę',
    plus_amount_more: '+ {amount} więcej',
    discount_percent: 'Rabat {percent}% zniżki lub więcej',
    float_limited: 'Zakres zużycia dla tej skórki jest ograniczony od {from} do {to}',
    your_favorite_items: 'Twoje ulubione przedmioty',
    additional_links: {
      title: 'Pozostałe linki',
      cases: 'Najlepsze skrzynki CSGO/CS2',
      item: 'Najlepsze skiny {item}',
      sell: 'Sprzedawaj',
      buy: 'Kupuj',
      sell_skins: 'Sprzedaj skiny {item}',
      buy_skins: 'Kupuj skiny {item}',
      knife: 'Najlepsze skiny Noże',
      glock: 'Najlepsze skiny Glock-18',
    }
  },
  bumps: {
    heading: 'Chciałbyś <span class="text-cp">sprzedać swoje itemy szybciej</span> bez konieczności obniżania ich ceny?',
    subheading: 'Coś dla Ciebie mamy!',
    how_it_works: '<span class="text-cp">Jak</span> to działa?',
    description: 'Na BitSkins dostępna jest opcja podbicia, która umożliwia Ci wyróżnienie swoich przedmiotów na stronie głównej, oraz w kilku innych miejscach na stronie. To doskonałe rozwiązanie dla kogoś kto  chce przyśpiszyć proces sprzedaży przedmiotów, bez konieczności obniżania ich ceny. Gdy podbijesz przedmiot zobaczy go więcej osób, dzięki czemu szansa na jego sprzedaż wzrasta. Możesz zacząć podbijać sobie przedmioty już od $0.75 lub mniej (zapoznaj się z naszymi paczkami podbić).',
    bumps_packages: 'Pakiety podbić',
    bumps: 'podbić',
    bumps_title: 'Podbicia',
    available_bumps: 'Dostępne podbicia',
    buy_selected_package: 'Kup wybraną paczkę',
    when_you_bump: 'Gdy podbijesz przedmiot pojawi się on w następujących miejscach:',
    step_1_title: 'Na stronie marketu w <span class="text-cp">górnym pasku</span>',
    step_2_title: 'Na stronie marketu w <span class="text-cp">głównej sekcji</span>',
    step_2_text: '(Tylko wtedy gdy opcja sortowania ustawiona jest na "wyróżnione". Jest to domyślnia opcja.)',
    step_3_title: 'Na <span class="text-cp">stronie głównej</span>',
    step_4_title: 'Na stronie przedmiotu w sekcji <span class="text-cp">podobne przedmioty</span>',
    step_5_title: 'W sekcji <span class="text-cp">sugerowane przedmioty</span>',
    after_bumping: '<span class="text-cp">Po podbiciu</span> przedmiotu zostanie on wyświetlony <span class="text-cp">na pierwszym miejscu</span> w każdej sekcji. <span class="text-cp">Jeśli jednak ktoś inny podbije swój item po Tobie</span>, wówczas twój przedmiot zostanie przesunięty na <span class="text-cp">drugie miejsce</span>. Twój przedmiot będzie widoczny w danej sekcji tak długo jak nie będzie wystarczającej liczby podbić, która go stamtąd wypchnie.',
    how_to_bump: '<span class="text-cp">Jak podbić</span> mój item?',
    how_to_1: 'Otwórz menu przedmiotu',
    how_to_2: 'Wybierz opcję <span class="text-cp">podbij</span>',
    how_to_3: 'Wybierz typ podbicia',
    how_to_4: 'Gotowe!',
    table: {
      item: 'Przedmiot',
      quantity: 'Ilość',
      left: 'Pozostało',
      period: 'Okres',
      created_at: 'Utworzono',
      updated_at: 'Zaktualizowano',
      next_bump_at: 'Następne podbicie',
      action: 'Akcja',
      status: 'Status',
    },
    auto_enabled: 'Włączono automatyczne podbijanie',
    auto_disabled: 'Wyłączono automatyczne podbijanie',
    single_bumped: 'Przedmiot został podbity!',
    your_active_x_autobumps: 'Twoje aktywne automatyczne podbicia ({x})',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Potwierdź anulowanie <span class="color-primary">zleceń kupna</span>',
    are_you_sure_that_you_want_to_cancel: 'Czy na pewno chcesz anulować wszystkie swoje zlecenia kupna?',
    create_buy_order: 'Utwórz <span class="text-cp">zlecenie kupna</span>',
    predict_place_in_queue: 'Oszacuj miejsce w kolejce',
    your_place_in_the_queue: 'Twoje miejsce w kolejce:',
    may_purchase_items_with_trade_hold: 'Zlecenia kupna mogą kupować przedmioty ze wstrzymaniem handlu.',
    create_a_buy_order_for_this_item: 'Utwórz zlecenie kupna dla tego przedmiotu',
    no_buy_orders_found: 'Nie znaleziono zleceń kupna',
    position_in_queue: 'Pozycja w kolejce',
    this_is_your_buy_order: '(to jest twoje zlecenie kupna)',
    skin_name: 'Nazwa skina:',
    offers_on_market: 'ofert na markecie',
  },
  instant_sell: {
    confirmation: 'Potwierdzenie natychmiastowej sprzedaży',
    you_can_sell_x: 'Możesz sprzedać AWP | Asiimov (Field-Tested) natychmiast i otrzymać $10.',
    the_funds_will_be_credited: 'Środki zostaną natychmiast zaksięgowane na Twoim koncie. Jeśli chcesz kontynuować, kliknij „Sprzedaj natychmiast”',
  },
  sort: {
    select_option: 'Wybierz opcję',
    apply: 'Zastosuj',
    clear: 'Wyczyść',
    default_order_placeholder: 'Wybierz opcję',
    select_order_placeholder: 'Wybierz sortowanie',
    default_sort: 'Sortowanie domyślne',
    custom_sort: 'Sortowanie własne',
    field: {
      price: 'Cena',
      discount: 'Zniżka',
      id: 'Data dodania',
      bumped_at: 'Wyróżnione',
      suggested_price: 'Sugerowana cena',
      asset_id: 'Data dodania',
      float_value: 'Zużycie',
      paint_index: 'Indeks farby',
      paint_seed: 'Ziarno farby',
      extras_1: 'Specjalna wartość',
      extras_1_fade: 'Gradient',
      collection: 'Kolekcja',
      amount: 'Kwota',
      name: 'Nazwa',
    },
    order: {
      price: {
        asc: 'Od najtańszego',
        desc: 'Od najdroższego',
      },
      discount: {
        desc: 'Od największej',
      },
      id: {
        asc: 'Od najstarszego',
        desc: 'Od najnowszego',
      },
      asset_id: {
        asc: 'Od najstarszego',
        desc: 'Od najnowszego',
      },
      bumped_at: {
        desc: 'Domyślny',
        asc: '',
      },
      default: {
        asc: 'Od najmniejszego',
        desc: 'Od największego',
      },
    },
  },
  pagination: {
    showing: 'widoczne',
    to: 'do',
    of: 'z',
    records: 'rekordów',
  },
  popups: {
    click_confirmation_link: 'Sprawdź swoją skrzynkę email i kliknij link potwierdzający, aby zakończyć proces.',
    steam_login_issue: {
      title: 'Problem z logowaniem Steam',
      an_error_occured: 'Podczas próby logowania przez Steam wystąpił błąd. Prosimy spróbować ponownie.',
    },
    steam_inventory_private: {
      title: 'Twój ekwipunek Steam jest <span class="text-cp">prywatny</span>',
      we_were: 'Nie byliśmy w stanie załadować twojego ekwipunku Steam. Prosimy zmienić status ekwipunku na publiczny.',
      you_can: 'Możesz to zrobić w ustawieniach na Steam. Pamiętaj, że wykrycie zmiany może potrwać do kilku minut.',
      steam_settings: 'Ustawienia steam',
    },
    steam_profile_private: {
      title: 'Twój profil Steam jest <span class="text-cp">prywatny</span>',
      your_steam_profile: 'Twój profil Steam jest prywatny, w związku z tym nie masz dostępu do tej strony / nie możesz wykonać tej czynności. Proszę zmień status swojego profilu na publiczny. Możesz to zrobić w ustawieniach Steam. Pamiętaj, że wykrycie zmian może zająć do kilku minut. Po dokonaniu zmian kliknij przycisk „Spróbuj ponownie”.',
      change_steam_status: 'Zmień status swojego profilu Steam:',
      try_again: 'Spróbuj ponownie',
    },
    account_deletion_in_progress: {
      title: 'Trwa usuwanie konta...',
      process_started: 'Rozpocząłeś proces usuwania konta.',
      account_will_be_deleted: 'Twoje konto zostanie usunięte',
      cancel_deletion: 'Anuluj usuwanie',
      confirm_deletion: 'Potwierdź usuwanie konta',
      check_your_email: 'Sprawdź swój email',
    },
    account_deletion_confirm: {
      title: 'Potwierdź usunięcie konta',
      subtitle: 'Czy na pewno chcesz usunąć swoje konto?',
      once_you_confirm: 'Po potwierdzeniu zostaniesz automatycznie wylogowany, a wszystkie twoje dane zostaną bezpowrotnie usunięte po upływie dwóch tygodni. Do tego czasu będziesz mógł anulować proces usuwania konta logując się na stronę.',
      once_your_account_is: 'Gdy twoje konto zostanie usunięte będziesz mógł utworzyć nowe konto logując się na stronę.',
      however_you_will_not: 'Nie będziesz miał jednak dostępu do usuniętych danych.',
      if_you_want_to_continue: 'Jeśli chcesz kontynuować kliknij "potwierdź" i kliknij w link który wysłaliśmy na twój adres email.',
      login: 'Aby potwierdzić usunięcie konta, musisz się zalogować',
      canceled: 'Usuwanie konta zostało anulowane',
      confirmed: 'Potwierdzono usunięcie konta',
    },
    account_deletion_check_your_email: {
      title: 'Sprawdź swój email',
      to_complete: 'Aby zakończyć proces usuwania konta kliknij w link, który wysłaliśmy na twój adres email.',
    },
    twofa_enable: {
      twofa_authentication_adds: 'Uwierzytelnianie dwustopniowe (2FA) dodaje dodatkową warstwę bezpieczeństwa do Twojego konta, wymagając dwóch metod (elementów) do zweryfikowania Twojej tożsamości. Włączenie 2FA jest zdecydowanie zalecane, aby zapewnić bezpieczeństwo twojego konta, ponieważ zapobiega niechcianym logowaniom bez dostępu do dodatkowego kodu 2FA.',
      setup_twofa: 'Skonfiguruj uwierzytelnienie dwustopniowe',
      if_you_dont_have_an_authenticator_app: 'Jeśli <span class="text-cp">nie masz</span> aplikacji uwierzytelniającej',
      we_recommend: '<p>Polecamy <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> or <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> dla użytkowników Androida i iOS. Jeśli chcesz używać aplikacji na komputerze, możesz pobrać i zainstalować <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> lub skorzystać z <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">wtyczki Google Authenticator</a> w twojej przeglądarce.',
      scan_the_qr_code: '<span class="text-cp">Zeskanuj</span> kod QR',
      open_your_authenticator_app: 'Otwórz aplikację uwierzytelniającą i zeskanuj kod QR lub wprowadź tajny klucz ręcznie.',
      secret_key: 'Tajny klucz',
      this_secret_key_will_be_valid_for_x_seconds: 'Tajny klucz będzie ważny przez <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'Zapisz tajny klucz w bezpiecznym miejscu. Dzięki niemu będziesz mógł odzyskać dostęp do swoich kodów 2FA,',
      enter_the_6_digit_code: 'Wprowadź <span class="text-cp">6-cyfrowy kod</span> wygenerowany przez twoją aplikację uwierzytelniającą',
      enter_code_from_the_email: 'Wprowadź kod z wiadomości <span class="text-cp">email</span>',
      enter_the_verification_code: 'Wprowadź kod weryfikacyjny, który wysłaliśmy na adres <span class="text-cp">{email}</span>.',
      desktop: 'Komputer',
      already_done: 'Włączyłeś już 2FA.',
      setup_email_before: 'Aby włączyć 2FA, musisz najpierw skonfigurować adres e-mail.',
    },
    twofa_enabled: {
      now_your_account_is: 'Od teraz twoje konto jest chronione przed uwierzytelnienie dwustopniowe.',
      all_future_logins: 'Każde przyszłe logowanie będzie wymagało wprowadzenia kodu wygenerowanego przez twoją aplikację.',
    },
    twofa_enter_code: 'Wprowadź kod 2FA wygenerowany przez twoją aplikację uwierzytelniającą.',
    twofa_disable: {
      title: 'Wyłącz uwierzytelnienie dwustopniowe',
      enter_the_6_digit: 'Wprowadź 6 cyfrowy kod wygenerowany przez twoją aplikację.',
      cannot_access: 'Nie masz dostępu do swojego kodu weryfikacyjnego? Prosimy o kontakt na ',
      enter_the_6_digit_code: 'Wprowadź 6-cyfrowy kod wygenerowany przez Twoją aplikację uwierzytelniającą.',
    },
    twofa_disabled: 'Twoje konto nie jest już chronione przez weryfikację dwustopniową.',
    order_unable_to_process: {
      title: 'Nie byliśmy w stanie <span class="text-cr">przetworzyć twojego zamówienia</span>',
      an_error_occurred: 'Podczas przetwarzania twojego zamówienia wystąpił błąd.<br> Prosimy o powrót do kasy i spróbowanie złożenia zamówienia ponownie.',
      back_to_checkout: 'Powrót do kasy',
      back_to_item: 'Powrót do przedmiotu',
      information: 'Jeśli ten problem występuje cały czas powinieneś skontaktować się z <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">naszym wsparciem</a> podając ten kod błędu:',
    },
    phone_number_add: {
      title: 'Dodaj swój numer telefonu',
      to_continue: 'Aby kontynuować najpierw musisz dodać numer telefonu do swojego konta.',
      add_number: 'Dodaj numer',
    },
    phone_number_confirmed: {
      title: 'Numer telefonu potwierdzony',
      your_phone_number: 'Twój numer telefonu został potwierdzony.',
    },
    phone_number_verify: {
      title: 'Zweryfikuj swój numer telefonu',
      to_verify: 'Aby zweryfikować swój numer telefonu wprowadź kod weryfikacyjny, który wysłaliśmy na',
      enter_sms_code: 'Wprowadź kod SMS',
      you_cannot_update: 'Na tym etapie nie możesz zaktualizować swojego numeru telefonu. Będziesz mógł to zrobić za {minutes} minut.',
    },
    phone_number_verification_in_progress: {
      title: 'Weryfikacja numeru telefonu w toku',
      if_you_wish: 'Jeśli chcesz możesz zaktualizować swój numer telefonu lub ponownie wysłać kod weryfikacyjny.',
      send_code: 'Wyślij kod',
    },
    email_address_add: {
      your_email_address: 'swój adres email',
      by_providing_my_email: 'Podając swój adres e-mail wyrażam zgodę na otrzymywanie informacji marketingowych',
      verification_in_progress: 'Weryfikacja email w toku',
      to_verify: 'Aby zweryfikować swój adres email musisz kliknąć w link, który wysłaliśmy na',
      if_you_wish: 'Jeśli chcesz możesz zaktualizować swój adres email lub ponownie wysłać link aktywacyjny.',
    },
    email_address_verify: {
      we_are_verifying: 'Weryfikujemy twój adres email i może to chwilę potrwać...',
      confirmed: 'Twój adres email został potwierdzony.',
    },
    email_address_confirmed: {
      title: 'Adres email potwierdzony',
      your_email_address: 'Twój adres email został potwierdzony.',
    },
    enter_your_trade_url: {
      title: 'Wprowadź swój <span class="text-cp">adres wymiany</span>',
      error_title: 'Nieprawidłowy <span class="text-cr">adres wymiany</span>',
      to_continue: 'Aby kontynuować najpierw musisz ustawić swój adres wymiany. Znajdziesz go',
      to_change: 'Twój adres wymiany jest nieprawidłowy. Wprowadź prawidłowy adres wymiany aby uzyskać dostęp do wszystkich funkcjonalności. Znajdziesz go',
      your_trade_url: 'Twój adres wymiany',
    },
    password_reset_enter_email: {
      forgot: 'Zapomniałeś',
      password: 'hasła?',
      dont_worry: 'Nie martw się, wprowadź poniżej swój adres e-mail.',
      we_will_send: 'Wyślemy Ci link do zresetowania hasła.',
      send_reset_link: 'Wyślij link resetujący',
      if_this_email: 'Jeśli ten adres email jest powiązany z kontem BitSkins,',
      you_will_receive: 'otrzymasz wiadomość z linkiem do zresetowania hasła.',
    },
    password_reset_new_password: {
      enter_your: 'Wprowadź swoje',
      new_password: 'nowe hasło',
      enter_password: 'Wprowadź hasło',
      repeat_password: 'Powtórz hasło',
      save_password: 'Zapisz hasło',
    },
    link_expired: {
      title: 'Link wygasł',
      the_process_cannot: 'Proces nie może zostać zakończony. Link już wygasł.',
      go_to_settings: 'Przejdź do ustawień',
    },
    wrong_link: {
      title: 'Nieprawidłowy link',
      we_were_unable: 'Nie mogliśmy przetworzyć Twojego żądania. Otworzyłeś nieprawidłowy link.',
    },
    trade_preparing: {
      title: 'Przygotowujemy twoją ofertę wymiany',
      processing: 'Może to potrwać kilka sekund...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'Oferta wymiany <span class="text-cp">została wysłana</span>',
      verify_info: 'Przed zaakceptowaniem oferty wymiany prosimy zweryfikować czy bot znajduje się w tej grupie Steam: <a rel="nofollow noopener noreferrer" target="_blank" href="https://steamcommunity.com/groups/bitskinsbots" class="text-cg">BitSkins, Inc: Bots</a>. Jeśli nie, odrzuć ofertę wymiany i <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cg">skontaktuj się z naszym wsparciem</a>. ID wymiany: <span class="text-cg">{trade_id}</span>. Token wymiany w wiadomości: <span class="text-cg">{trade_token}</span>.',
    },
    trade_done: {
      title: 'Oferta wymiany została <span class="text-cp">zaakceptowana</span>',
      listed: 'Z powodzeniem wystawiłeś swoje przedmioty na sprzedaż. Możesz nimi zarządzać w <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">zakładce sprzedaży</a>.',
      see_listed: 'Przedź do sprzedaży',
      withdrawn: 'Z powodzeniem wypłaciłeś swoje przedmioty.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'Oferta wymiany została',
      declined: 'odrzucona',
      if_you: 'Jeśli sam jej nie odrzuciłeś oznacza to, że ktoś korzysta z twojego konta i twojego przedmioty mogą być narażone na kradzież.',
      to_stay: 'Aby chronić swoje przedmioty powinieneś działać szybko i wykonać następujące kroki:',
      step_revoke: 'Unieważnij swój klucz Steam Web API.',
      step_revoke_btn: 'UNIEWAŻNIJ KLUCZ API',
      step_password: 'Zmień swoje hasło na Steam.',
      step_password_btn: 'ZMIEŃ HASŁO',
      step_deauth: 'Deautoryzuj wszystkie urządzenia na Steam.',
      step_deauth_btn: 'DEAUTORYZUJ URZĄDZENIA',
      step_trade: 'Utwórz nowy Steam trade URL.',
      step_trade_btn: 'UTWÓRZ NOWY TRADE URL',
      step_new: 'Ustaw nowy Steam trade URL na BitSkins.',
      step_new_btn: 'USTAW NOWY TRADE URL',
      step_try: 'Spróbuj ponownie zdeponować przedmioty i sprawdź, czy problem nadal występuje.',
      step_try_if: 'Jeśli problem będzie się powtarzać, zaprzestań wszystkich ofert wymiany i skontaktuj się z naszym wsparciem.',
      contact_support: 'NAPISZ DO WSPARCIA',
      information: 'Pamiętaj, że żaden z naszych pracowników ani botów nigdy nie poprosi Cię o jakiekolwiek depozyty przez czat Steam, Discord, ani nigdzie indziej - każdy kto twierdzi, że jestem administratorem, etc... jest oszustem i najprawdopodobniej próbuje Cię okraść. Bądź ostrożny!',
    },
    trade_failed: {
      offer_failed_title: 'Oferta wymiany <span class="text-cr">nie powiodła się</span>',
      offer_failed_text: 'Niestety twoja oferta wymiany nie powiodła się. Prosimy spróbować ponownie.',
      offer_failed_to_create_title: 'Utworzenie oferty wymiany <span class="text-cr">nie powiodło się</span>',
      offer_failed_to_create_text: 'Niestety nie mogliśmy utworzyć Twojej oferty wymiany. Prosimy spróbować ponownie.',
      contact_support: 'Jeśli ten problem występuje cały czas powinieneś skontaktować się z naszym <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">wsparciem</a>.',
      support_page: 'wsparcia technicznego',
      cannot_process: 'Nie możemy przetworzyć Twojej oferty wymiany',
      unfortunately_we_were_unable: 'Niestety nie byliśmy w stanie przetworzyć twojej oferty wymiany. Najprawdopodobniej masz już aktywną ofertę wymiany na te przedmioty.',
    },
    items_not_available: {
      title: 'Przedmioty nie są już dostępne',
      unfortunately: 'Niestety przedmioty z twojego koszyka nie są już dostępne na sprzedaż.',
      dont_worry: 'Nie martw się, na stronie marketu znajdziesz mnóstwo przedmiotów.',
      unavailable_items: 'Niedostępne przedmioty',
      back_to_market: 'Powrót do marketu',
    },
    bump_purchase_confirmation: {
      title: 'Potwierdzenie zakupu',
      do_you_want_to_purchase: 'Chcesz kupić <span class="text-cp">{quantity} podbić</span> za <span class="text-cp">{price}</span>?',
      bumps_package: 'Pakiety podbić',
    },
    bump_start: {
      title: 'Podbij swój przedmiot',
      bump_your_item: 'Podbij swój przedmiot aby wyróżnić go na stronie marketu oraz w kilku innych miejscach na stronie.<br> Może Ci to pomóc w szybszej sprzedaży przedmiotu, ponieważ zostanie on zauważony przez większą liczbę osób.<br> Jeśli chcesz się dowiedzieć więcej o funkcji podbijania',
      click_here: 'kliknij tutaj',
      single_bump: 'Pojedyncze podbicie',
      autobumps: 'Automatyczne podbicia',
      one_bump: '1 podbicie',
      this_option_single_bump: 'Ta opcja podbije twój przedmiot tylko raz i kosztuje ona <span class="text-cp">$0.75</span>. Jeśli masz już na swoim koncie dostępne podbicia, wówczas z twojego salda nie zostaną pobrane żadne środki.',
      this_option_autobumps: 'Ta opcja będzie podbijać twój przedmiot co wybrany okres czasu. Jeśli masz już na swoim koncie dostępne podbicia, wówczas z twojego salda nie zostaną pobrane żadne środki. Jeśli skończą Ci się podbicia, wówczas z twojego konta będzie pobierane <span class="text-cp">$0.75</span> przy każdym podbiciu. <span class="text-cp">Możesz kupić więcej podbić zawczasu</span> i jednocześnie <span class="text-cp">zaoszczędzić trochę pieniędzy</span>. Przewiń w dół aby sprawdzić pakiety podbić.',
      bump_every: 'Podbijaj co',
      bumps_amount: 'Ilość podbić',
      delayed_start: 'Opóźniony start',
      delayed_start_description: 'Zaznaczenie tej opcji spowoduje, że twoje pierwsze podbicie zostanie opóźnione o wybrany okres czasu.',
    },
    bump_stop: {
      title: 'Zatrzymaj automatyczne podbicia',
      do_you_want: 'Czy chcesz zatrzymać automatyczne podbicia dla tego przedmiotu?',
    },
    bulk_buy: {
      bulk_buy: 'Zakup <span class="text-cp">hurtowy</span>',
      maximum_items_you_can_buy: 'Maksymalna liczba przedmiotów, które możesz kupić w tej cenie:',
      may_purchase_items_with_trade_hold: 'Funkcja hurtowego kupowania może kupować przedmioty ze wstrzymaniem handlu.',
    },
    fresh_account: {
      fresh_account: 'Nowe konto',
      fresh_account_inventory_visibility: 'Przejdź do <a class="text-cp" href="https://steamcommunity.com/" target="_blank">Steam</a> i zmień widoczność ekwipunku na publiczny.',
    },
  },
  affiliate: {
    affiliate_code: 'Kod afiliacyjny',
    affiliate_link: 'Link afiliacyjny',
    level: 'Poziom',
    levels: '<span class="text-cp">Poziomy </span>afiliacyjne',
    our_levels: 'Nasze poziomy',
    your_code: '<span class="text-cp">Twój kod </span>afiliacyjny',
    your_affiliate_statistics: '<span class="text-cp">Twoje statystyki </span>afiliacyjne',
    earn_money_by_simply_sharing: '<span class="text-cp">Zarabiaj pieniądze</span> poprzez dzielenie się swoją miłością do BitSkins ze swoimi odbiorcami!',
    percent_from_sale_fee: '{value}% z opłaty za sprzedaż',
    your_percentage: 'Twój procent',
    generated: 'Wygenerowane',
    total_number_of_active_referrals: 'Całkowita liczba aktywnych użytkowników',
    individual_affiliate_program: 'Indywidualny program partnerski',
    if_you_or_your_business: 'Jeśli Ty lub Twoja firma jest zaangażowana w branżę e-sportową lub generuje duży zasięg w mediach społecznościowych, prosimy o kontakt pod adresem <span>partnership{\'@\'}bitskins.com</span>. Jesteśmy w stanie zaoferować Ci indywidualne warunki partnerskie.',
    ad_info: 'Jeśli nie widzisz tego pola, spróbuj wyłączyć blokadę reklam.',
    join_the_bitskins_affiliate: 'Dołącz do programu partnerskiego BitSkins i zarabiaj prowizje od każdej sprzedaży dokonanej za pośrednictwem unikalnego linku partnerskiego. Niezależnie od tego, czy masz wielu obserwujących czy tylko kilku bliskich przyjaciół, im więcej udostępniasz, tym więcej zarabiasz.',
    tile_1_title: 'Udostępnij BitSkins swoim odbiorcom',
    tile_1_description: 'W kilka sekund utwórz własny link partnerski i zacznij udostępniać go znajomym lub obserwującym.',
    tile_2_title: 'Obserwuj, jak rosną Twoje zyski',
    tile_2_description: 'Otrzymasz prowizję od transakcji dokonanych przez każdego kwalifikującego się* zaproszonego użytkownika. Niezależnie od tego, czy kupuje, czy sprzedaje przedmioty',
    tile_3_title: 'Zgłoś swoje zarobki',
    tile_3_description: 'Środki uzyskane z programu partnerskiego możesz przeznaczyć na zakup przedmiotów lub wypłacić z BitSkins. To zależy od Ciebie!',
    tile_disclaimer: '* Szczegółowe zasady i warunki programu, w tym zasady kwalifikacji zaproszonych użytkowników, znajdują się w <a href="https://bitskins.com/terms-of-use#chapter-18" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">BitSkins Affiliate Program Terms and Conditions</a>.',
    kyc_you_cannot_use: 'Nie możesz korzystać z systemu partnerskiego, ponieważ nie przeszedłeś procedury KYC. Możesz teraz rozpocząć proces weryfikacji.',
    invited_referrals: 'Poleceni użytkownicy',
    active_referrals: 'Aktywni użytkownicy',
    your_percentage_sales_fee: 'Twoja procentowa opłata za sprzedaż',
    your_total_earnings: 'Twoje całkowite zarobki',
    available_earnings: 'Dostępne zarobki',
    you_can_claim_your_earnings_one_a_day: 'Możesz odebrać swoje zarobki raz dziennie. Po ich odebraniu w ciągu 24 godzin pojawią się one na saldzie do wypłaty. Minimalna kwota do wypłaty to',
    to_reach_the_next_level: 'Aby osiągnąć wyższy poziom i otrzymywać wyższe prowizje, musisz wygenerować <span class="text-cp">{x}</span> sprzedaży dzięki swoim poleconym.',
    any_user_that_registers_from_your_affiliate_link: 'Każdy użytkownik który zarejestruje się z Twojego linku partnerskiego zostanie automatycznie przydzielony jako Twój polecony',
    my_earnings: '<span class="text-cgs">Moje</span> zarobki',
    referred_users: '<span class="text-purple">Poleceni</span> użytkownicy',
    code_updated: 'Pomyślnie zaktualizowano kod partnera',
    not_enough_money: 'Za mało pieniędzy na wypłatę',
    account: 'Konto',
    referrals_sales: 'Historia sprzedaży poleconych',
    save_code: 'Zapisz kod',
  },
  profile: {
    hi: 'Cześć',
    nav: {
      account: 'Konto',
      wallet: 'Portfel',
      transactions: 'Transakcje',
      statistics: 'Statystyka',
      affiliate: 'System poleceń',
      company: 'Firma',
      trades: 'Wymiany',
      items_history: 'Historia przedmiotów',
    },
    top_star: {
      you_are: 'Jesteś',
      top_star: 'GWIAZDĄ',
      good_to_see_you: 'Hej „{username}”, jak dobrze cię widzieć w BitSkins!',
      appreciate_using: 'Doceniamy, że zdecydowałeś się skorzystać z naszej platformy,',
      extra_settings: 'dlatego przygotowaliśmy dla Ciebie dodatkowe ustawienia.',
      show_nickname_selling: 'Pokaż mój pseudonim na stronie przedmiotu podczas sprzedaży',
      show_nickname_store: 'Zaznacz mój pseudonim na stronie sklepu',
    },
    security: {
      you_can_access_your_account: 'Możesz uzyskać dostęp do swojego konta za pomocą klucza API. Nasza dokumentacja API znajduje się',
      api_status: 'Status API',
      security: 'Bezpieczeństwo',
      twofa: 'Uwierzytelnianie dwustopniowe',
      temporarily_block: 'Tymczasowo zablokuj moje konto',
      temporarily_block_description: 'Jeśli uważasz, że Twoje konto zostało przejęte, możesz je tymczasowo zablokować.\nOdblokujemy Twoje konto po skontaktowaniu się z naszym wsparciem.',
      block_my_account: 'Zablokuj moje konto',
      delete_account: 'Usuń konto',
      delete_my_account: 'Usuń moje konto',
      sessions: 'Sesje',
      close_all_sessions: 'Zamknij wszystkie sesje',
      current_session: 'Obecna sesja',
      active_sessions: 'Aktywne Sesje',
      no_other_sessions: 'Brak innych sesji',
      removed: 'Usunięta',
      online: 'Aktywna',
      api_key: 'Klucz API',
      api_key_not_available: 'Klucz API jest widoczny tylko raz podczas jego tworzenia',
      sensitive_hidden: 'Ukryte wrażliwe dane',
      ip_whitelist: 'Biała lista adresów IP',
      add_ip_to_whitelist: 'Dodaj adres IP do whitelisty',
      temp_blocked: 'Twoje konto zostało tymczasowo zablokowane.\nProsimy o skontaktowanie sie z naszym wsparciem w celu wyjaśnienia sytuacji.',
      temporarily_block_my_account: 'Tymczasowo zablokuj moje konto',
      temporarily_block_title: 'Tymczasowo <span class="text-cr">zablokuj moje konto</span>',
      disable_api_confirm: 'Potwierdź wyłączenie API',
      disable_api_content: 'Jesteś pewny, że chcesz wyłączyć API?',
    },
    basic: {
      basic_information: 'Podstawowe informacje',
      username: 'Nazwa użytkownika',
      change_username: 'Zmień nazwę użytkownika',
      registration_date: 'Data rejestracji',
      email: 'E-mail',
      change_email: 'Zmień adres e-mail',
      password: 'Hasło',
      change_password: 'Zmień hasło',
      phone: 'Numer telefonu',
      change_phone: 'Zmień numer',
      hide_balance: 'Ukryj saldo',
      hide_balance_description: 'Ilość środków zostanie ukryta z nagłówka, nadal będzie widoczna po naciśnięciu na portfel.',
    },
    store: {
      my_store: 'Mój sklep',
      store_url: 'Adres sklepu',
      id_store: 'ID SKLEPU',
      hide_store: 'Ukryj stronę swojego sklepu',
      url_copied: 'Adres URL sklepu został skopiowany',
      store: 'sklep',
      store_alias: 'Alias sklepu',
      total_items: 'Łączna liczba przedmiotów:',
      games: 'Gry:',
    },
    setting: {
      account_email: 'Adres e-mail',
      update_email: 'Zaktualizuj e-mail',
      setup_email: 'Ustaw e-mail',
      update_password: 'Zaktualizuj hasło',
      set_password: 'Ustaw hasło',
      enter_current_password: 'Wprowadź bieżące hasło',
      current_password: 'Aktualne hasło',
      enter_new_password: 'Wprowadź nowe hasło',
      repeat_new_password: 'Powtórz nowe hasło',
      save_new_password: 'Zapisz nowe hasło',
      new_password: 'Nowe hasło',
      repeat_password: 'Powtórz hasło',
      account_2fa: 'Konto 2FA',
      enable_2fa: 'Włącz 2FA',
      disable_2fa: 'Wyłącz 2FA',
      password_changed: 'Hasło zostało zmienione',
      currency_and_language: 'Waluta i język',
      bs_settings: 'Ustawienia BitSkins',
    },
    transaction: {
      transaction_history: 'Historia transakcji',
      bought_items: 'Kupione przedmioty',
      operation: 'Operacja',
      trade_id: 'ID oferty',
      loading_trade_offers: 'Ładowanie ofert wymiany',
      no_trades_found: 'Nie znaleziono żadnych ofert wymiany',
      id: 'ID',
      date: 'Data',
      game: 'Gra',
      items: 'Przedmioty',
      status: 'Status',
      time_left: 'Pozostały czas',
      action: 'Akcja',
      trades_active: 'Aktywne wymiany',
      trades_history: 'Historia wymian',
      balance: 'Saldo',
      history: 'Historia transakcji',
      pending: 'Transakcje w toku',
      reports: 'Wyeksportowane raporty',
      active_locks: 'Aktywne blokady',
      export: 'Eksportuj',
      export_to_csv: 'Eksportuj do .CSV',
      export_description: 'Wybierz miesiąc i rok dla którego chcesz wygenerować raport.',
      export_condition: 'Akceptowane są tylko ubiegłe miesiące.',
      the_report_will_appear_in_the: 'Raport pojawi się w zakładce',
      tab_once_the_export_process_is_complete: 'po zakończeniu procesu eksportu.',
      amount: 'Kwota',
      type: 'Typ',
      details: 'Szczegóły',
      fee: 'Opłata',
      buyer_country: 'Kraj kupującego',
      seller_country: 'Kraj sprzedawcy',
      price: 'Cena',
      item_name: 'Nazwa przedmiotu',
      asset_id: 'ID przedmiotu',
      period_from: 'Okres od',
      period_to: 'Okres do',
      created_at: 'Utworzono',
      updated_at: 'Zaktualizowano',
      more: 'więcej',
      hide: 'ukryj',
    },
  },
  fee: {
    individual: 'Indywidualny',
    individual_fee: 'Unikalna opłata',
    custom_sale_fee: 'Twoja unikalna opłata',
    your_current_fees: 'Twoje obecne opłaty za sprzedaż',
    high_tier: 'High tier',
    fee: 'Opłata',
    fee_up_to: 'opłaty',
    sale_fee: 'Opłata za sprzedaż',
    sales_fees: 'Opłaty za sprzedaż',
    see_all_levels: 'Zobacz wszystkie poziomy',
    see_all_plans: 'Zobacz wszystkie plany',
    you_are_on_the: 'Jesteś na',
    individual_level: '<span class="text-csfl6">poziomie indywidualnym</span>',
    maximum_sales_fee: 'Maksymalna opłata za sprzedaż: {value}',
    your_individual_fee: 'Twoja indywidualna opłata: {value}',
    your_total_sale_volume: 'Twój całkowity wolumen sprzedaży wynosi',
    sale_fees_will_be_lowered: 'Opłaty za sprzedaż będą obniżane w miarę sprzedawania większej liczby przedmiotów',
    level: 'poziom',
    your_level: 'Twój poziom:',
    your_plan: 'Twój plan:',
    progress: 'Postęp:',
    max_level: 'Max poziom',
    next_level: 'Następny poziom:',
    total_income: 'Całkowity przychód',
    total_revenue: 'Całkowity dochód',
    sold_items: 'Sprzedane przedmioty',
    sale_volume: 'Wolumen sprzedaży',
    page: {
      sales_fees_depends_on_two_factors: 'Na BitSkins <span class="text-cp">OPŁATY ZA SPRZEDAŻ</span> zależą od dwóch czynników:',
      the_price: '1. Ceny za którą sprzedajesz swój przedmiot',
      the_listing_type: '2. Typu oferty:',
      listing_type_public: 'Publiczna - twój przedmiot jest widoczny dla wszystkich użytkowników na stronie',
      listing_type_private: 'Prywatna - twój przedmiot jest widoczny tylko dla użytkowników którym udostępnisz do niego link',
      fee_explanation: 'Im większa jest cena za którą sprzedajesz swój przedmiot tym mniejsza jest opłata za sprzedaż którą zapłacisz. Standardowa opłata za sprzedaż wynosi od 2.5% (dla ofert prywatnych) do maksymalnie 10% (dla ofert publicznych). Dodatkowo posiadamy 5 różnych poziomów sprzedażowych, które pozwalają Ci obniżych opłaty za sprzedaż jeszcze bardziej. Zasada jest prosta - im więcej sprzedajesz tym mniejsze opłaty za sprzedaż płacisz. Możesz obniżyć swoje opłaty za sprzedaż do 2.4% (dla ofert prywatnych) lub do 9.8% (dla ofert publicznych). Nasz system opłat jest transparentny i nie ma w nim żadnych ukrytych kosztów.',
      default_sales_fees_title: '<span class="text-cp">Domyślne</span> opłaty za sprzedaż',
      default_sale_fees_description: 'Jeśli dopiero zaczynasz i nie sprzedałeś jeszcze żadnych przedmiotów, wówczas opłaty za sprzedaż będą następujące:',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">Jak obniżyć</span> moje opłaty za sprzedaż?',
      how_to_reduce_my_sales_fees_description: 'Na BitSkins mamy 5 poziomów sprzedażowych. Każdy z nich (z wyjątkiem Poziom 1) obniża twoją opłatę za sprzedaż o 0.05%. Aby podnieść swój poziom, musisz sprzedać przedmioty w określonym przedziale cenowym.',
      sales_fees_levels: 'Poziomy <span class="text-cp">opłat sprzedażowych</span>',
      price_range: 'Przedział cenowy',
      total_sales: 'Całkowita sprzedaż',
      fee_reduced_by: 'Opłata obniżona o',
      individual_sales_fees_title: 'Indywidualne opłaty sprzedażowe',
      individual_sales_fees_description: 'Jeśli aktywnie korzystasz z BitSkins i twój miesięczny obrót wynosi przynajmniej <span class="span text-csfl6">{amount}</span>, nie zwlekaj i odezwij się do nas. Możemy zaoferować <span class="span text-csfl6">Ci jeszcze mniejsze opłaty za sprzedaż</span> i <strong>dodatkową pomoc</strong>.',
    },
    sales_fees_will_be_lowered: 'Opłaty za sprzedaż będą obniżane wraz ze sprzedażą większej liczby przedmiotów.',
    custom_sale_fee_description: 'Opłaty będą pobierane na korzyść użytkownika (w miarę możliwości pobierana będzie niższa opłata za sprzedaż)',
  },
  copy: {
    text_copied: 'Skopiowano tekst',
    cannot_copy: 'Nie można skopiować',
    name_copied: 'Nazwa skopiowana',
    cannot_copy_name: 'Nie można skopiować nazwy',
    copy_link: 'Skopiuj link',
  },
  discord: {
    discord: 'Discord',
    already_connected: 'Już połączono',
    something_went_wrong: 'Coś poszło nie tak',
    success: 'Połączono z Discordem!',
    loading: 'Ładowanie...',
    connect_with_discord: 'Połącz się z Discordem',
  },
  error: {
    error_404: 'Błąd 404',
    page_not_found: 'Strona nie znaleziona',
  },
  kyc: {
    accepted: 'Zaakceptowany',
    description_1: 'Aby zapewnić bezpieczeństwo transakcji dokonywanych za pośrednictwem naszego serwisu oraz zachować zgodność z obowiązującymi przepisami AML/KYC, wymagamy od Ciebie poddania się procesowi weryfikacji danych (KYC). Istnieją trzy poziomy weryfikacji. Każdy z poziomów zwiększa lub całkowicie znosi limity płatności i daje Ci dostęp do nowych metod płatności.',
    description_2_start: 'Szczegółowe zasady i warunki dotyczące procesu weryfikacji KYC są opisane w naszych warunkach użytkowania. Pragniemy zapewnić, że wszelkie podane przez Państwa dane będą wykorzystywane zgodnie z ',
    description_2_end: 'Inicjując proces weryfikacji KYC wyrażasz zgodę na przetwarzanie przez nas Twoich danych w prawnie uzasadnionych celach.',
    personal_data: 'Dane osobiste',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    street_name: 'Nazwa ulicy',
    street_number: 'Numer',
    postal_code: 'Kod pocztowy',
    city: 'Miasto',
    province: 'Województwo',
    country: 'Kraj',
    start_kyc_verification: 'Rozpocznij weryfikację KYC',
    kyc_verification_required: 'Wymagana weryfikacja KYC',
    uploaded: 'Załadowany',
    document_type: {
      id: 'ID',
      driving_license: 'Prawo jazdy',
      passport: 'Paszport',
      other: 'Inny',
    },
    limit: {
      crypto_withdraw: 'Roczny limit wypłat kryptowalut w wysokości {amount}',
      crypto_withdraw_unlimited: 'Nieograniczone wypłaty kryptowalut',
      non_crypto_withdraw: 'Roczny limit wypłat innych niż kryptowaluty w wysokości {amount}',
      non_crypto_withdraw_unlimited: 'Nieograniczone wypłaty inne niż kryptowaluty',
      crypto_deposit: 'Roczny limit wpłat kryptowalut w wysokości {amount}',
      crypto_deposit_unlimited: 'Nieograniczone depozyty kryptowalut',
      non_crypto_deposit: 'Limit depozytów innych niż kryptowaluty w wysokości {amount}',
      non_crypto_deposit_unlimited: 'Nieograniczone depozyty inne niż kryptowaluty',
    },
    your_kyc_needs_an_update: 'Twój KYC wymaga <span class="color-update">aktualizacji</span>',
    need_update_reason: 'Niestety nie mogliśmy zatwierdzić Twojego konta z następujących powodów:',
    open_support: 'Przedź do wsparcia',
    your_kyc_has_been_denied: 'Twój KYC <span class="color-denied">został odrzucony</span>',
    denied_description: 'Twoje zgłoszenie KYC zostało odrzucony, dlatego nie możesz ponownie przejść przez weryfikację KYC.',
    please_contact_our: 'Prosimy o kontakt z naszym',
    support: 'wsparciem',
    clarify_the_situation: 'w celu wyjaśnienia sytuacji.',
    your: 'Twoja',
    reason: 'Powód:',
    verification: 'weryfikacja KYC',
    uverification: 'Weryfikacja',
    pending: 'oczekująca',
    pending_description: 'To wszystko! Dziękujemy za przejście przez proces weryfikacji. Twoje dane zostały pomyślnie przesłane. Dołożymy wszelkich starań, aby jak najszybciej sprawdzić Twoją aplikację. Zwykle zajmuje to nie więcej niż 12 godzin. Gdy twoje konto zostanie zatwierdzone poinformujemy Cię o tym mailowo. Dziękujemy za cierpliwość.',
    do_you_need_help: 'Potrzebujesz pomocy? Prosimy o kontakt z naszym',
    support_center: 'Centrum Wsparcia',
    back_to_kyc: 'Powrót do KYC',
    go_to_home: 'Idź do strony głównej',
    level_0: 'Poziom 0',
    level_1: 'Poziom 1',
    level_2: 'Poziom 2',
    limits: 'Limity',
    benefits: 'Korzyści',
    requirements: 'Wymagania',
    no_requirements: 'Brak wymagań',
    proof_of_address: 'Potwierdzenie adresu',
    all_benefits_from_the_basic_level: 'Wszystkie korzyści z poziomu podstawowego',
    personal_information: 'Informacje osobiste',
    identity_document: 'Dokument tożsamości',
    selfie: 'Selfie',
    all_benefits_from_level_1: 'Wszystkie korzyści z poziomu 1',
    current: 'Aktualny',
    upending: 'W toku',
    update: 'Aktualizuj',
    verification_blocked: 'Weryfikacja zablokowana',
    verify_now: 'Wypełnij teraz',
    you_need_to_upgrade_to_level_1: 'Musisz przejść na poziom 1',
    upgrade_to_level_1: 'Przejdź przez poziom 1',
    upgrade_to_level_2: 'Przejdź przez poziom 2',
    kyc_verification: 'Weryfikacja KYC',
    everything_done: 'Wszystko zrobione!',
    proof_of_residency: 'Dowód zamieszkania',
    you_current_residential_address: 'Twój aktualny adres zamieszkania',
    only_x_minutes: 'Tylko {minutes} minut!',
    personal_verification: 'Weryfikacja osobista',
    identity_verification: 'Weryfikacja tożsamości',
    take_a_selfie: 'Zrób selfie',
    step: 'Krok {step}',
    country_of_residence: 'Kraj zamieszkania',
    full_name: 'Pełne imię i nazwisko',
    date_of_birth: 'Data urodzenia',
    nationality: 'Narodowość',
    choose_your_document: 'Wybierz swój dokument',
    choose_document_description_1: 'Wybierz dokument, którego chcesz użyć podczas weryfikacji.',
    choose_document_description_2: 'Akceptujemy tylko ważne dokumenty wydane przez rząd.',
    choose_document_description_3: 'Wszelkie inne dokumenty, których nie ma na liście, zostaną odrzucone.',
    document_number: 'Numer dokumentu',
    country_of_issue: 'Kraj wydania',
    document_issue_date: 'Data wystawienia dokumentu',
    document_expiry_date: 'Data ważności dokumentu',
    files_requirements: 'Wymagania dotyczące plików',
    format: '{format} lub {or} format',
    maximum_file_size: 'Maksymalny rozmiar pliku {size}',
    minimum_picture_size: 'Minimalny rozmiar obrazu {size} pikseli',
    not_accepted_documents: 'Nie akceptowane dokumenty',
    expired: 'Wygasłe',
    edited: 'Edytowane',
    black_and_white: 'Czarno-białe',
    broken_or_damaged: 'Złamany lub uszkodzony',
    illegible_blurred_or_reflective: 'Nieczytelne, zamazane lub prześwietlone',
    cut_off_or_overcropped: 'Obcięte',
    upload_front_page: 'Przód dokumentu',
    upload_back_page: 'Tył dokumentu',
    selfie_description: 'Prześlij zdjęcie, na którym trzymasz <span class="color-primary">swój dokument tożsamości</span> i <span class="color-primary">kartkę ze swoim imieniem i nazwiskiem, tekstem „BitSkins.com” i dzisiejszą datą</span>.',
    example_of_correctly_taken_photo: 'Przykład poprawnie wykonanego zdjęcia',
    with_sunglasses_cap_or_mask: 'Z okularami przeciwsłonecznymi, czapką lub maską',
    information_covered_by_finger: 'Informacje w dokumencie są zakryte palcami',
    face_covered_by_document: 'Twoja twarz jest zakryta dokumentem',
    out_of_focus: 'Twoja twarz lub dokument są nieostre',
    upload_selfie: 'Prześlij selfie',
    send_level_1_kyc_request: 'Wyślij żądanie KYC poziomu 1',
    address_line_1: 'Wiersz adresu 1',
    address_line_2_optional: 'Wiersz adresu 2 (opcjonalnie)',
    state_or_province: 'Stan lub województwo',
    proof_of_residency_description: 'Prześlij dokument potwierdzający Twój aktualny adres zamieszkania, który podałeś w poprzednim kroku.<br> Dokument nie może być wystawiony wcześniej niż 3 miesiące temu. Upewnij się, że na dokumencie jest widoczne Twoje imię i nazwisko.',
    upload_document: 'Prześlij dokument',
    accepted_documents: 'Akceptowane dokumenty',
    utility_bills: 'Rachunki za usługi komunalne',
    bank_statements: 'Wyciągi bankowe',
    tax_returns: 'Zwrot podatku',
    government_letters: 'Pisma rządowe',
    other_document_residential: 'Inne dokumenty potwierdzające aktualny adres zamieszkania',
    send_level_2_kyc_request: 'Wyślij żądanie KYC poziomu 2',
    level: 'Poziom KYC',
    middle_name: 'Drugie imię',
    deleted_description: 'Twój KYC został odrzucony. Możesz ponownie przejść przez proces weryfikacji.',
    submit: 'Wyślij',
    submit_correct: 'Wyślij poprawne informacje',
    next: 'Dalej',
    send_to_verify: 'Wyślij do weryfikacji',
    document_verification: 'Weryfikacja dokumentu',
    please_reupload_following_photos: 'Prosimy o ponowne przesłanie poniższych zdjęć',
    please_reupload: 'Prosimy o ponowne przesłanie',
    we_need_additional_information: 'Potrzebujemy dodatkowych informacji',
    field: {
      document_image_a: 'Przednia strona twojego dokumentu',
      document_image_b: 'Tylna strona twojego dokumentu',
      user_image: 'Twoje selfie',
      address_image: 'Dowód zamieszkania',
      additional_selfie: 'Dodatkowe selfie',
    },
    back_to_bitskins: 'Powrót do BitSkins',
    upload: 'Prześlij',
    image_uploaded: 'Obraz przesłany',
    your_kyc_verification: 'Twoja weryfikacja KYC',
    kyc_title: '<span class="text-cp">Weryfikacja</span> Know Your Customer',
    kyc_verification_span: 'Weryfikacja <span class="color-primary">KYC</span>',
    file_format_not_supported: 'Ten format pliku nie jest obsługiwany.',
    the_file_is_too_big: 'Plik {file_name} jest za duży ({file_size}), <br> maksymalnie {size_limit}.',
    withdrawals: 'Wypłaty',
    get_to_the_next_level: 'Przejdź na wyższy poziom, aby pozbyć się<br> limitów i uzyskać dostęp<br>do nowych metod płatności.',
    after_the_first_page_is_validated: 'Po zatwierdzeniu pierwszego zdjęcia będziesz mógł przesłać drugą stronę.',
    checkbox_title: 'Potwierdź, że następujące informacje są widoczne na Twoim selfie',
    checkbox_1: 'Dokument tożsamości przesłany w poprzednim kroku.',
    checkbox_2: 'Kartka z imieniem i nazwiskiem, tekstem "BitSkins.com" i dzisiejszą datą.',
    checkbox_3: 'Potwierdzam, że przesłany dokument nie został wystawiony wcześniej niż 3 miesiące temu.',
    checkbox_additional: 'Jeśli przynajmniej jeden z powyższych elementów nie jest widoczny na zdjęciu, aplikacja zostanie automatycznie odrzucona.',
    checkbox_3_additional: 'Jeśli przesłany dokument został wystawiony wcześniej niż 3 miesiące temu, aplikacja zostanie automatycznie odrzucona.',
  },
  camera: {
    cancel: 'Anuluj',
    check_permissions: 'Sprawdź uprawnienia',
    take_a_new_photo: 'Zrób nowe zdjęcie',
    take_a_photo: 'Zrób zdjęcie',
    use_photo: 'Użyj zdjęcia',
    use_camera: 'Użyj kamerki',
    we_will_need_access_to_your_camera: 'Aby kontynuować, będziemy potrzebować dostępu do Twojej kamery.',
    please_follow_these_steps: 'Prosimy o wykonanie następujących kroków',
    select_the_camera_icon: 'Wybierz <strong>ikonę kamery</strong> w pasku adresu',
    select_always_allow_access: 'Wybierz <strong>Zawsze zezwalaj na dostęp do kamery</strong>',
    select_done: 'Wybierz <strong>Gotowe</strong>',
  },
  review: {
    leave_a_review: 'Zostaw recenzję',
    if_youre_happy: 'Jeśli <span class="color-primary">jesteś zadowolony</span> z naszych usług, ',
    trustpilot: 'Trustpilot',
    sharing_experience: '. Podziel się swoim doświadczeniem, aby nam pomóc. Dziękujemy!',
    our_reviews: 'Nasze recenzje',
    we_would_appreciate: 'będzie nam niezmiernie miło jeśli <span class="color-primary">podzielisz się swoimi doświadczeniami na Trustpilot</span>. Dziękujemy!',
    if_youre_happy_we_would_appreciate: 'Jeśli <span class="text-cp">jesteś zadowolony</span> z usługi, będziemy bardzo wdzięczni, jeśli zostawisz nam <span class="text-cp">recenzję na portalu Trustpilot</span>, dzieląc się swoim doświadczeniem, aby nam pomóc. Dziękujemy!',
  },
  support: {
    center: 'Centrum Wsparcia',
    tickets_list: 'Lista zgłoszeń',
    create_ticket: 'Utwórz zgłoszenie',
    category: {
      market_deposit: 'Depozyt przedmiotu',
      market_withdraw: 'Wypłata przedmiotu',
      crypto_deposit: 'Depozyt kryptowaluty',
      crypto_withdraw: 'Wypłata kryptowaluty',
      other: 'Inne',
      payments: 'Płatności',
      payment_crypto_deposit: 'Depozyt kryptowalut',
      payment_crypto_withdraw: 'Wypłata kryptowalut',
      payment_standard_deposit: 'Standardowa metoda wpłaty',
      payment_standard_withdraw: 'Standardowa metoda wypłaty',
      market: 'Market',
      market_item_issue: 'Problem z przedmiotem',
      market_buy_orders: 'Zlecenie kupna',
      market_bulk_buy: 'Zakup hurtowy',
      market_missing_screenshot: 'Brak screenshota',
      market_missing_float: 'Brak floatu',
      market_wrong_price: 'Nieprawidłowa cena Steam',
      market_other: 'Inne',
      trading: 'Wymiany',
      trading_deposit: 'Depozyt przedmiotu',
      trading_withdraw: 'Wypłata przedmiotu',
      account: 'Konto',
      account_2fa: 'Problem z 2FA',
      account_email: 'Problem z adresem email',
      account_kyc: 'KYC',
      account_affiliate: 'System partnerski',
      account_restrictions: 'Ograniczenia',
      account_other: 'Inne',
      bug_report: 'Zgłoszenie błędu',
      api: 'API',
      suggestions: 'Sugestie',
      business_inquiry: 'Zapytanie biznesowe',
      general_inquiry: 'Zapytanie ogólne',
    },
    submit_ticket: 'Wyślij zgłoszenie',
    close_ticket: 'Zamknij zgłoszenie',
    submit_disclaimer: 'Aby przyspieszyć naszą pracę i otrzymać odpowiedź tak szybko, jak to możliwe, upewnij się, że nie otwierasz wielu zgłoszeń dotyczących tego samego problemu. Średni czas odpowiedzi to <strong>kilka godzin</strong>. Możesz skontaktować się z nami w języku <strong>angielskim, polskim i szwedzkim</strong>. Dziękujemy za współpracę.',
    enter_your_message: 'Wpisz swoją wiadomość',
    new_ticket: 'Nowe zgłoszenie',
    your_ticket: 'Twoje zgłoszenie',
    ticket_has_been_closed: 'Zgłoszenie zostało <span>zamknięte</span>',
    conversation_history: 'Historia konwersacji:',
    your_reply: 'Twoja odpowiedź...',
    last_reply_by: 'Ostatnia odpowiedź od',
    send: 'Wyślij',
    ticket: 'Zgłoszenie',
    title: 'Tytuł',
    extra: {
      txid_url: 'TXID/url',
      amount: 'Kwota',
      crypto: 'Kryptowaluta',
      disclaimer_visa_1: 'Prosimy pamiętać, że to normalne, że zanim pieniądze pojawią się na Twoim koncie bankowym, może minąć do 5 dni roboczych.',
      disclaimer_visa_2: 'Prosimy upewnić się, że karta na którą próbujesz wypłacić pieniądze to VISA, a nie MasterCard. Obecnie nie obsługujemy wypłat Mastercard.',
      card_digits: '4 ostatnie cyfry Twojej karty',
      binance_id: 'Twój identyfikator Binance',
      wallet_address: 'Adres portfela',
      provider: 'Dostawca',
      transaction_id: 'Identyfikator transakcji',
      type: 'Typ',
      method: 'Metoda',
      item_link: 'Link do przedmiotu',
      bot_received_item: 'Link do profilu Steam bota, który otrzymał twoje przedmioty',
      trade_offer_id: 'Identyfikator oferty wymiany',
      can_be_found_here: 'można go znaleźć tutaj',
      email: 'Wprowadź email',
    },
    ticket_has_been_closed_by: 'Zgłoszenie zostało <span>zamknięte</span> przez <span>{by}</span>',
    bitskins_team: 'Zespół BitSkins',
    delete_link: 'Usuń link',
    add_link: 'Dodaj link',
  },
  service: {
    market: {
      buy: 'Kupno',
      sell: 'Sprzedaż',
      fee: 'Opłata za sprzedaż',
      buy_order: 'Zlecenie kupna',
      bargain: 'Negocjacja',
      instant_sell: 'Natychmiastowa sprzedaż',
      bump: 'Podbicie',
      bump_package: 'Pakiet podbić',
    },
    deposit: {
      bitcoin: 'Wpłata BTC',
      litecoin: 'Wpłata LTC',
      ethereum: 'Wpłata ETH',
      unlimint: 'Wpłata kartą bankową',
      binance_pay: 'Wpłata przez Binance Pay',
      binancepay: 'Wpłata przez Binance Pay',
      available_coupons: 'Dostępne kupony:',
      redeem_coupon: 'Wykorzystaj kupon',
      enter_coupon_code: 'Wprowadź kod kuponu',
      open_binance_website: 'Otwórz stronę Binance',
      list_of_active_transactions: 'Lista aktywnych transakcji:',
      transaction_needs_at_least_x_confirmations: 'Transakcja potrzebuje przynajmniej {x} potwierdzień zanim środki pojawią się na twoim koncie.',
      x_day_deposit_limit: '<span class="color-primary">{y} limit {z} </span> wynosi <span class="color-primary"> {limit} </span> lub ekwiwalent w obcej walucie.',
      deposit_per_day: '<span class="text-cp">Dziennie</span> możesz dokonać <span class="text-cp">maksymalnie {day} wpłat</span>.',
      day: 'Dzienny',
      billing_information: '<span class="text-cp">Dane</span> rozliczeniowe',
      coupon: {
        coupon: 'Kupon',
        make_a_gift: 'Zrób <span class="text-cp">prezent</span> sobie lub komuś innemu',
        bitskins_coupons_are_a_good_alternative: 'Kupony BitSkins to dobra alternatywa dla standardowych metod płatności i świetny pomysł na prezent. Możesz kupić je od naszych partnerów, którzy oferują wiele metod płatności.',
        dont_wait: '<span class="text-cp">Nie czekaj i doładuj swoje saldo</span> przy użyciu kuponu BitSkins lub zrób komuś <span class="text-cp">oryginalny prezent </span> (wszyscy znamy kogoś z pustym ekwipunkiem).',
        kinguin: 'Kinguin (nowe niższe opłaty)',
      },
      crypto: {
        get_wallet_address: 'Uzyskaj adres portfela',
        your_wallet_address: 'Twój adres portfela',
        this_address_is_only_for_x: 'Ten adres jest tylko dla wpłat {x}. Nie wysyłaj na ten adres żadnego innego krypto.',
        this_address_will_not_expire: 'Ten adres nie wygaśnie. Możesz go użyć w dowolnym momencie.',
        choose_alternative_address: 'Wybierz alternatywny adres',
        the_acutal_amount_you_will_be_credited: 'Faktyczna kwota którą otrzymasz zależy od ceny {x} w momencie otrzymania przez nas płatności.',
        only_l1_transactions: '<span class="text-cy">Obsługujemy tylko transakcje L1. Nie używaj wewnętrznych transakcji i smart kontraktów!</span>',
      },
      zen: {
        zen: 'Wpłać przez ZEN',
        deposit_started: 'Wpłata przez ZEN rozpoczęta, ',
        open_the_zen_deposit_page: 'otwórz stronę wpłaty ZEN',
        processing_fee: 'ZEN doliczy do transakcji opłatę manipulacyjną zależną od wybranej metody płatności.<br> Finalna kwota transakcji będzie widoczna na ich stronie internetowej.',
        each_transaction_is_reviewed: 'Każda transakcja jest sprawdzana przez ZEN Pay i jej zakończenie może zająć <span class="text-cp">od minuty do kilku godzin</span>.',
      },
      the_minimum_deposit_amount_is: 'Minimalna kwota wpłaty to {amount}.',
      the_maximum_deposit_amount_is: 'Maksymalna kwota wpłaty to {amount}.',
      gift_code: 'Kupon',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">Oferujemy wypłaty tylko na binance.com (binance.us nie jest wspierany).</span>',
      bitcoin: 'Wypłata BTC',
      litecoin: 'Wypłata LTC',
      ethereum: 'Wypłata ETH',
      unlimint: 'Wypłata na kartę VISA',
      tipalti: {
        tipalti: 'Wypłata przez Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti umożliwia Ci wypłatę środków na konto bankowe i PayPal.',
        you_dont_have_a_tipalti_acount: 'Nie masz konta Tipalti?',
        you_have_to_create_an_account: 'Aby wypłacać środki przez Tipalti najpierw musisz założyć konto na ich stronie internetowej.<br> Możesz to zrobić klikając na poniższy przycisk.',
        create_tipalti_account: 'Utwórz konto Tipalti',
        check_your_email: 'Prosimy sprawdzić <span class="text-cp">swoją skrzynkę email</span> i kliknąć w link potwierdzający w celu zakończenia procesu tworzenia konta. Jeśli nie możesz znaleźć wiadomości email w swojej skrzynce odbiorczej, prosimy sprawdzić folder ze spamem.',
        payment_method: 'Metoda płatności',
        tipalti_panel: 'Panel Tipalti',
        tipalti_payouts_incur_a_fee: 'Wypłaty Tipalti zawierają opłatę, która może wynosić do $26. Opłata ta zależy od wybranej metody płatności. Poniżej znajdziesz tabelę z opłatą dla każdej metody płatności.',
        fee_per_payment: 'Opłata za płatność',
        rejection_fee: 'Opłata za odrzucenie',
        echeck_local: 'eCheck (Lokalny)',
        paypal_non_us: 'PayPal (Rezydent spoza USA)',
        paypal_us: 'PayPal (Rezydent z USA)',
        wire_transfer_non_us_non_usd: 'Przelew bankowy (Rezydent spoza USA, płatne w walucie innej niż USD)',
        wire_transfer_non_us_usd: 'Przelew bankowy (Rezydent spoza USA, płatne w USD)',
        wire_transfer_us: 'Przelew bankowy (Rezydent z USA)',
        up_to_21_usd: 'do $21.00',
        up_to_2_usd: 'do $2.00',
      },
      payoneer: 'Wypłata przez Payoneer',
      binance_pay: 'Wypłata przez Binance Pay',
      binancepay: 'Wypłata przez Binance Pay',
      p2p: 'Transfer P2P',
      transfer_funds: 'Przenieś środki',
      payouts_are_performed_on_a_rolling_basis: 'Wypłaty są realizowane na bieżąco do 5 minut po ich zażądaniu.',
      your_payout_will_be_processed_at_the_current_rate: 'Twoja wypłata zostanie zrealizowana według aktualnego kursu.',
      please_verify_the_wallet_address: 'Prosimy o weryfikację adresu portfela. Nie możemy zwrócić nieprawidłowej wypłaty.',
      bitcoin_withdrawals_are_temporarily_processed_in_batches: 'AKTUALIZACJA: Wypłaty Bitcoin są tymczasowo przetwarzane partiami co 30 minut.',
      the_data_controller: 'Administratorem danych i kontrahentem Unlimitent w zakresie realizowanych przez nich płatności jest Bitskins Sp. z o.o. z siedzibą w 40-246 Katowice, Porcelanowa 23, Polska, zarejestrowana pod numerem: 0000810143 - więcej szczegółów znajdziesz w Polityce Prywatności oraz Warunkach Użytkowania.',
      visa_withdrawals_are_processed_instantly: 'Wypłaty VISA są przetwarzane natychmiast. Jednak w niektórych przypadkach może minąć nawet kilka dni, zanim pieniądze pojawią się na Twoim koncie bankowym.',
      card_info: 'Informacje o karcie',
      ccv: 'CCV',
      add_new_deposit_needed: 'Dodaj nową (wymagany depozyt)',
      you_can_have_max_3_bank_cards: 'Do konta możesz mieć przypisane maksymalnie 3 karty bankowe.',
      your_cards_amount: '<span class="text-cp">Twoje</span> karty ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'Minimalna kwota wypłaty to {x}.',
      the_maximum_withdraw_amount_is_x: 'Maksymalna kwota wypłaty to {x}.',
      enter_amount: 'Wprowadź kwotę',
      go_to_card_deposit: 'Przejdź do wpłaty kartą',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Aby móc wypłacić środki najpierw musisz zweryfikować swoją kartę. Możesz to zrobić wpłacając $1.',
      deposited_funds_are_non_withdrawable: 'Pamiętaj, że zdeponowane środki nie podlegają wypłacie i można je wykorzystać wyłącznie na zakupy.',
      we_do_not_support_mastercard_withdrawals: 'Nie obsługujemy wypłat na karty MasterCard oraz na karty wydane w następujących krajach: Bośnia i Hercegowina, Kanada, Egipt, Japonia, Kambodża, Korea (Republika), KOSOWO, Macedonia Północna, Stany Zjednoczone Ameryki, Argentyna.',
      your_card_is_valid_until: 'Twoja karta jest ważna do 16.02.2023, 15:35 (UTC). Po tym czasie będziesz musiał ponownie zweryfikować swoją kartę poprzez wpłatę $5.',
      card_verification_required: '<span class="text-cp">Wymagana weryfikacja</span> karty',
      card: 'Karta',
      add_new_card: '<span class="text-cp">Dodaj nową</span> kartę',
      save_card: 'Dodaj kartę',
      how_to_find_my_binance_id: 'Jak znaleźć moje ID użytkownika (BUID) na Binance?',
      how_to_find_my_pay_id: 'Jak znaleźć mój Pay ID na Binance?',
      how_to_find_my_email: 'Jak znaleźć mój email na Binance?',
      binance_id: 'Binance ID',
      receiver_type: 'Typ odbiorcy',
      i_do_not_have_a_binance_account: 'Nie mam konta Binance',
      i_have_a_binance_account: 'Mam konto Binance',
      binance_account: '<span class="text-cp">Konto</span> Binance',
      the_fee_is_already_included_in_the_current_x_rate: 'Opłata {fee}% jest już uwzględniona w bieżącym kursie {x}.',
      checkbox: 'Potwierdzam, że zapoznałem się i zgadzam się z warunkami zawartymi w sekcji <span class="text-cw">WAŻNE</span>, która znajduje się poniżej.',
    },
    wallet: {
      transfer: 'Transfer środków',
      refund: 'Zwrot środków',
      available_payment_methods: 'Dostępne metody płatności',
      bank_cards: 'Karty bankowe',
      kyc_required_for_this_payment_method: 'Nie możesz korzystać z tej metody płatności, ponieważ nie przeszedłeś(aś) przez procedurę KYC. Możesz teraz rozpocząć proces weryfikacji.',
      kyc_limit_exceeded: 'Nie możesz użyć tej metody płatności, ponieważ przekroczyłeś limit transakcji dla swojego poziomu KYC. Możesz teraz rozpocząć proces weryfikacji, aby usunąć ograniczenia.',
      no_limit: 'Brak limitu',
      limits_info: 'Na Bitskins <strong>każda transakcja ma swój własny licznik czasu i limit, który resetuje się rok po dokonaniu transakcji</strong>. Maksymalne kwoty, które możesz wpłacić lub wypłacić są pokazane na wykresach. Limity możesz zwiększyć lub całkowicie się ich pozbyć przechodząc przez procedurę KYC.',
      crypto_deposits: 'Wpłaty krypto',
      crypto_withdrawals: 'Wypłaty krypto',
      standard_deposits: 'Standardowe wpłaty',
      standard_withdrawals: 'Standardowe wypłaty',
      coupons_are_excluded_from_the_limit: '* kupony są wyłączone z limitu',
      x_type_does_not_incur_any_fees: '{type} {x} nie zawierają żadnych opłat.',
      incur_fees_of: 'zawierają opłaty w wysokości',
      plus: ' plus ',
      deposit: 'wpłaty',
      withdraw: 'wypłat',
      the_minimum_type_amount_is: '<span class="color-primary">Minimalna kwota {type}</span> wynosi',
      the_maximum_type_amount_is: '<span class="color-primary">Maksymalna kwota {type}</span> wynosi',
      due_to_unstable_crypto_network: 'Ze względu na niestabilną sieć krypto mogą wystąpić pewne opóźnienia.',
      binance_temporarily_disabled: 'Wypłaty Binance są wyłączone do poniedziału (28.08.2023)',
      left: 'zostało',
      increase_limits: 'Możesz zwiększyć ten limit przechodząc przez <a href="https://bitskins.com/kyc/" rel="nofollow noopener noreferrer" target="_blank" class="link-primary">procedurę KYC</a>.',
      crypto_wallet_address: 'Adres portfela {currency}',
    },
  },
  enum: {
    service: {
      market: {
        buy: 'Kupno',
        sell: 'Sprzedaż',
        fee: 'Opłata za sprzedaż',
        buy_order: 'Zlecenie kupna',
        bargain: 'Negocjacja',
        instant_sell: 'Natychmiastowa sprzedaż',
        bump: 'Podbicie',
        bump_package: 'Pakiet podbić',
      },
      deposit: {
        bitcoin: 'Wpłata BTC',
        litecoin: 'Wpłata LTC',
        ethereum: 'Wpłata ETH',
        unlimint: 'Wpłata kartą bankową',
        zen: 'Wpłać przez ZEN',
        gift_code: 'Kupon podarunkowy',
        binancepay: 'Wpłata przez Binance Pay',
      },
      withdraw: {
        bitcoin: 'Wypłata BTC',
        litecoin: 'Wypłata LTC',
        ethereum: 'Wypłata ETH',
        unlimint: 'Wypłata na kartę VISA',
        tipalti: 'Wypłata przez Tipalti',
        payoneer: 'Wypłata przez Payoneer',
        binancepay: 'Wypłata przez Binance Pay',
        p2p: 'Transfer P2P',
      },
      wallet: {
        transfer: 'Transfer środków',
        refund: 'Zwrot środków',
      },
      marketing: {
        coupon: 'Kupon',
        referral: 'Polecenie',
        affiliate: 'Program partnerski',
      },
    },
    report_type: {
      balance: 'Saldo',
      sell: 'Sprzedane',
      buy: 'Kupione',
    },
    report_status: {
      empty: 'Brak',
      pending: 'W toku',
      done: 'Ukończony',
    },
    autobump_period: {
      hour_1: '1 godz',
      hour_3: '3 godz',
      hour_6: '6 godz',
      hour_12: '12 godz',
      hour_24: '24 godz',
      hour_48: '48 godz',
    },
    autobump_status: {
      cancelled: 'Anulowany',
      pending: 'W toku',
      active: 'Aktywny',
      not_enough_bumps: 'Brak podbić',
      finished: 'Zakończono',
    },
    inventory_status: {
      issue: 'Problem',
      not_available: 'Niedostępny',
      deleted: 'Usunięty',
      withdrawn: 'Wypłacony',
      delisted: 'Wycofany',
      ready: 'Gotowy',
      listed: 'Wystawiony',
      listed_private: 'Wystawiony prywatnie',
      sold: 'Sprzedany',
      withdraw_queue: 'Wypłata w kolejce',
      withdraw_pending: 'Wypłata w toku',
      instant_sell: 'Natychmiastowa sprzedaż',
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins oferuje bezproblemową platformę do kupowania i sprzedawania twoich przedmiotów CS2, DOTA2, TF2, RUST. Wybieraj z szerokiej oferty karabinów, noży, rękawic i nie tylko. Dołącz teraz, aby handlować z łatwością!',
    home_title: 'BitSkins.com — Kupuj i sprzedawaj skórki CS2. Szybki, łatwy i bezpieczny handel',
    home_description: 'BitSkins oferuje bezproblemową platformę do kupowania i sprzedawania twoich przedmiotów CS2, DOTA2, TF2, RUST. Wybieraj z szerokiej oferty karabinów, noży, rękawic i nie tylko. Dołącz teraz, aby handlować z łatwością!',
    support_title: 'Wsparcie BitSkins: uzyskaj pomoc w zakresie potrzeb handlowych CS2',
    support_description: 'Potrzebujesz pomocy w handlu CS2? Odwiedź stronę wsparcia BitSkins, aby uzyskać szybką pomoc. Nasz zespół jest tutaj, aby odpowiedzieć na Twoje pytania, rozwiązać problemy i udzielić wskazówek.',
    item_title: '{item} - skórki {game} | Znajdź i handluj pożądanymi przedmiotami {game}',
    item_description_csgo: 'Odkrywaj i handluj pożądanymi skórkami CS2 na BitSkins. Zapoznaj się z naszą bogatą kolekcją karabinów, noży, rękawic i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast. Zacznij przeglądać już teraz!',
    item_description_cs2: 'Odkrywaj i handluj pożądanymi skórkami CS2 na BitSkins. Zapoznaj się z naszą bogatą kolekcją karabinów, noży, rękawic i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast. Zacznij przeglądać już teraz!',
    item_description_dota2: 'Odkrywaj i handluj pożądanymi skórkami DOTA2 na BitSkins. Zapoznaj się z naszą bogatą kolekcją totemów, muzyki, zestawów i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast. Zacznij przeglądać już teraz!',
    item_description_tf2: 'Odkrywaj i handluj pożądanymi skórkami TF2 na BitSkins. Zapoznaj się z naszą bogatą kolekcją przedmiotów ozdobnych, drwin, skrzyń i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast. Zacznij przeglądać już teraz!',
    item_description_rust: 'Odkrywaj i handluj pożądanymi skórkami RUST na BitSkins. Zapoznaj się z naszą bogatą kolekcją ubrań, broni, zasobów i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast. Zacznij przeglądać już teraz!',
    market_title: 'Market BitSkins: Z łatwością eksploruj i handluj przedmiotami {game}',
    market_description_csgo: 'Wejdź na Market BitSkins, aby bez trudu eksplorować i handlować szeroką gamą przedmiotów CS2. Odkryj najlepsze oferty na skórki, klucze, kapsuły i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast.',
    market_description_cs2: 'Wejdź na Market BitSkins, aby bez trudu eksplorować i handlować szeroką gamą przedmiotów CS2. Odkryj najlepsze oferty na skórki, klucze, kapsuły i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast.',
    market_description_dota2: 'Wejdź na Market BitSkins, aby bez trudu eksplorować i handlować szeroką gamą przedmiotów DOTA2. Odkryj najlepsze oferty na totemy, muzykę, zestawy i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast.',
    market_description_tf2: 'Wejdź na Market BitSkins, aby bez trudu eksplorować i handlować szeroką gamą przedmiotów TF2. Odkryj najlepsze oferty na przedmioty ozdobne, drwiny, skrzynie i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast.',
    market_description_rust: 'Wejdź na Market BitSkins, aby bez trudu eksplorować i handlować szeroką gamą przedmiotów RUST. Odkryj najlepsze oferty na ubrania, broń, zasoby i nie tylko. Kupuj, sprzedawaj lub wypłacaj natychmiast.',
    market_item_title: 'Market BitSkins: {skin} : {game} Market',
    store_title: 'Sklep użytkownika BitSkins: {alias} - Prezentacja przedmiotów {game}',
    store_description: 'Sklep użytkownika BitSkins służy do prezentacji i sprzedaży twoich przedmiotów. Ustaw ceny, nawiąż kontakt z kupującymi i zaznacz swoją obecność w społeczności handlowej.',
    login_title: 'Logowanie BitSkins: Bezpieczny dostęp do twojego konta handlowego CS2',
    login_description: 'Zaloguj się bezpiecznie na swoje konto BitSkins. Uzyskaj dostęp do swojego ekwipunku CS2, zarządzaj przedmiotami, wykonuj transakcje i ciesz się bezproblemowym handlem.',
    steam_login_title: 'Zaloguj się przez Steam',
    profile_title: 'Ustawienia twojego konta',
    wallet_title: 'Twoje środki BitSkins',
    affiliate_title: 'Panel partnerski BitSkins: Zdobywaj nagrody za rekomendacje',
    affiliate_description: 'Dołącz do programu afiliacyjnego BitSkins i zdobywaj nagrody przez polecanie miłośników skinów. Skorzystaj z lukratywnego programu partnerskiego, śledź polecenia i maksymalizuj swoje zarobki.',
    statistics_title: 'Statystyki sprzedaży BitSkins: odkryj trendy rynkowe i spostrzeżenia',
    statistics_description: 'Przeglądaj obszerne statystyki BitSkins, aby uzyskać cenny wgląd w trendy handlowe CS2. Analizuj dane rynkowe, popularność przedmiotów i nie tylko, w celu optymalizacji swojej strategii handlowej.',
    sales_fees_title: 'Opłaty za sprzedaż BitSkins: przejrzyste opłaty dla twoich sprzedaży CS2',
    sales_fees_description: 'Uzyskaj jasne zrozumienie struktury opłat sprzedażowych na BitSkins. Nasze przejrzyste opłaty zapewniają uczciwość i prostotę dla twoich sprzedaży CS2. Dowiedz się więcej.',
    checkout_title: 'Koszyk BitSkins: Wygodna realizacja transakcji dla przedmiotów CS2',
    checkout_description: 'Uprość swoje doświadczenia handlowe CS2 dzięki koszykowi BitSkins. Z łatwością zarządzaj swoimi przedmiotami, przeglądaj zamówienie i przejdź do bezpiecznej kasy. Ciesz się bezproblemowym procesem handlowym już dziś!',
    steam_inventory_title: 'Mój ekwipunek Steam {game}',
    bs_inventory_title: 'Mój ekwipunek BitSkins {game}',
    selling_inventory_title: 'Moje wystawione przedmioty {game}',
    buy_order_create_title: 'Tworzenie zleceń kupna {game}',
    buy_order_active_title: 'Aktywne zlecenia kupna {game}',
    buy_order_title: 'Zlecenia kupna {game}',
    trades_active_title: 'Aktywne wymiany',
    trades_history_title: 'Historia wymian',
    transactions_title: 'Transakcje',
    favorites_title: 'Ulubione przedmioty',
    kyc_title: 'Formularz aplikacyjny Know Your Customer (KYC).',
    tos_title: 'Warunki użytkowania BitSkins: Wytyczne dotyczące bezpiecznego i zaufanego handlu',
    tos_description: 'Zapoznaj się z naszymi Warunkami użytkowania, w celu bezpiecznego i zaufanego handelu. Zapoznaj się z naszymi zasadami i obowiązkami. Handluj bezpiecznie na BitSkins.',
    privacy_policy_title: 'Polityka prywatności BitSkins: Ochrona Twoich danych osobowych',
    privacy_policy_description: 'Przeczytaj Politykę prywatności BitSkins, aby dowiedzieć się w jaki sposób chronimy i przetwarzamy Twoje dane osobowe. Zaufanie i przejrzystość leżą u podstaw naszego zaangażowania.',
    cookie_policy_title: 'Polityka plików cookie BitSkins: Twoja prywatność jest dla nas istotna',
    cookie_policy_description: 'W BitSkins cenimy Twoją prywatność. Przeczytaj naszą Politykę plików cookie, aby zrozumieć, w jaki sposób używamy plików cookie i podobnych technologii. Twoje zaufanie i bezpieczeństwo danych są naszymi najwyższymi priorytetami.',
    docs_v1_title: 'BitSkins API V1: Starsza wersja API',
    docs_v1_description: 'Zintegruj BitSkins API V1, w celu zapewnienia bezproblemowego handelu. Uzyskaj dostęp do dokumentacji, aby zoptymalizować swoje możliwości handlowe. Uaktualnij do najnowszej wersji, aby uzyskać dostęp do nowych funkcji.',
    docs_v2_title: 'BitSkins API V2: Najnowsza wersja API',
    docs_v2_description: 'Odblokuj nowe funkcje dzięki BitSkins API V2. Popraw swoje strategie handlowe i efektywność. Zapoznaj się z naszą obszerną dokumentacją już teraz!',
    docs_migration_title: 'Migracja API BitSkins: Bezproblemowe przejście do nowego API',
    docs_migration_description: 'Bezproblemowo migruj do nowego API BitSkins, korzystając z naszego obszernego przewodnika. Zapoznaj się ze zaktualizowanymi funkcjami i procesami integracji, w celu uzyskania lepszego doświadczenia z handlu.',
    major_title: 'Wygraj wycieczkę na major Counter-Strike 2!',
    major_description: 'Doświadcz niezrównanego luksusu i komfortu w wykwintnych 5-gwiazdkowym hotelu, idealnych na niezapomniany wypad z przyjacielem.',
  },
  alt: {
    envelope: 'Koperta',
    app_store: 'Sklep Apple',
    google_store: 'Sklep Google',
  },
  time: {
    seconds: 'sekund',
  },
  calendar: {
    week: 'Tydzień',
    month: 'Miesiąc',
    lifetime: 'Ogółem',
  },
  docs: {
    docs: 'Dokumentacja',
    api: 'API',
    api_v1: 'API V1 (Bramka)',
    api_v2: 'API V2',
    documentation: 'Dokumentacja',
    api_migration_guide: 'Przewodnik migracji API',
    request_parameters: 'Parametry zapytania',
    sample_request: 'Przykładowe zapytanie',
    sample_response: 'Przykładowa odpowiedź',
    request_schema: 'Schemat zapytania',
    enums: 'ENUMY',
  },
  share: {
    share_on_twitter: 'Udostępnij na Twitterze',
    share_on_facebook: 'Udostępnij na Facebooku',
    share_on_telegram: 'Udostępnij na Telegramie',
  },
  telegram: {
    already_connected: 'Już połączony',
    something_went_wrong: 'Coś poszło nie tak',
    success: 'Sukces!',
    loading: 'Ładowanie...',
  },
  wallet: {
    deposit_type: '{type} {source}',
    coupon_redeemed: 'Wykorzystałeś kupon o wartości {amount}',
    balance_changed: 'Saldo zostało zaktualizowane',
    transfer_p2p_confirm: 'Potwierdź transfer środków na p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Musisz potwierdzić transfer',
    transfer_p2p_success: 'Twoje środki zostały przekazane na twoje konto p2p.bitskins.com',
    transfer_funds: 'Przekaż fundusze',
    deposit_started: 'Depozyt rozpoczęty',
    card_removed: 'Karta usunięta',
    confirm_card_remove: 'Czy na pewno chcesz usunąć tę kartę?',
    delete_card: 'Usuń kartę',
    deposit: 'wpłaty',
    withdraw: 'wypłaty',
    security_code: 'Kod bezpieczeństwa',
    security_code_ccv: 'Kod bezpieczeństwa (CCV)',
    card_number: 'Numer karty',
    full_name: 'Imię i nazwisko',
    month_expired: 'Termin ważności (MM/RRRR)',
    addr_line_1: 'Adres rozliczeniowy (wiersz 1)',
    addr_line_2: 'Adres rozliczeniowy (wiersz 2)',
    zip: 'Kod pocztowy',
    city: 'Miasto',
    country: 'Kraj',
    withdraw_only_to_visa: 'Możesz wypłacić środki tylko na kartę Visa',
    card_country_is_restricted: 'Niestety nie realizujemy wypłat na karty wydane w {country}',
    method: {
      zen: 'ZEN',
      litecoin: 'Litecoin',
      ethereum: 'Ethereum',
      bitcoin: 'Bitcoin',
      coupon: 'kuponami',
      binance_pay: 'Binance Pay',
      card: 'kartą kredytową/debetową',
      visa: 'na karty VISA',
    },
  },
  twofa: {
    required: 'Wymagane uwierzytelnianie dwuskładnikowe',
    required_for_this_payment_method: 'Nie możesz użyć tej metody płatności, ponieważ nie skonfigurowałeś uwierzytelniania dwuskładnikowego.',
    you_can_start_now: 'Możesz teraz rozpocząć proces konfiguracji.',
    setup: 'Skonfiguruj 2FA',
    why_we_require: 'Kliknij aby przeczytać - Dlaczego wymagamy 2FA do wypłat?',
  },
  password_strong: {
    minimum: 'Hasło musi mieć co najmniej {value} znaków',
    maximum: 'Hasło musi mieć maksymalnie {value} znaków',
    lowercase: 'Hasło musi mieć co najmniej 1 małą literę',
    uppercase: 'Hasło musi mieć co najmniej 1 wielką literę',
    numeric: 'Hasło musi mieć co najmniej 1 znak numeryczny',
    special: 'Hasło musi zawierać co najmniej 1 znak specjalny',
  },
  help_center: {
    help_center: 'Centrum pomocy',
    hello: 'Cześć, jak możemy pomóc?',
    create_ticket: 'Utwórz zgłoszenie',
    contact_us: 'Napisz do nas',
    guide: 'Przewodnik',
    top_articles: 'Top artykuły',
    didnt_find: 'Nie znalazłeś tego co potrzebujesz?',
    article: 'Artykuł',
    articles: 'Artykuły',
    general: 'Ogólne',
    fees: 'Opłaty',
    buying_selling: 'Kupowanie i sprzedawanie',
    deposit_withdrawal: 'Wpłaty i wypłaty',
    deposit: 'Wpłaty',
    withdrawal: 'Wypłaty',
    refunds: 'Zwroty',
    user_account: 'Konto użytkownika',
    affiliate: 'System poleceń',
    partnership: 'Współpraca',
    scam: 'Podejrzenie oszustwa',
    was_helpful: 'Czy ten artykuł był pomocny?',
    found_helpful: '{yes} z {max} uznało za pomocny',
    faq: '<span class="color-primary">Najczęściej</span> zadawane pytania',
    no_questions_found: 'Nie znaleziono pytań',
    skins: 'Skórki',
    currency: 'Waluta',
    items: 'Przedmioty',
    other: 'Inne',
    tickets: 'Zgłoszenia',
    assistance: 'Wsparcie',
    bots: 'Boty',
    account_deletion: 'Usunięcie konta',
    account_2fa: 'Konto - uwierzytelnianie dwuetapowe',
    read_more: 'czytaj więcej z tej kategorii',
  },
  faq: {
    creating_a_ticket: 'tworząc zgłoszenie',
    creating_new_ticket: 'tworząc nowe zgłoszenie',
    market_page: 'stronę marketu',
    account_settings: 'ustawienia konta',
    selling_section: 'sekcja sprzedaży',
    bitskins_inventory_section: 'sekcja ekwipunku BitSkins',
    bitskins_inventory: 'ekwipunek BitSkins',
    google_support: 'wsparcie Google',
    kraken_auth: 'Kraken - Synchronizacja czasu 2FA aplikacji Authenticator',
    deposit_method: 'metoda wpłaty',
    deposit_option: 'opcji wpłaty',
    withdrawal_option: 'opcji wypłaty',
    withdrawal_page: 'stronie wypłat',
    deposit_withdrawal_section: 'sekcji wpłat/ wypłat',
    or: 'albo',
    or_by: 'albo przez',
  },
  screenshot: {
    ticket_title: 'Problem ze zrzutem ekranu {id}',
    ticket_body: 'Chciałbym zgłosić, że zrzut ekranu dla elementu {id} nie został poprawnie wygenerowany.⏎Wersja zrzutu ekranu: {version}.⏎Link do zrzutu ekranu: {link}',
    ticket_filled: 'Formularz został wypełniony automatycznie.',
  },
  major: {
    btn_snap: 'Zrób zdjęcie i wygraj teraz!',
    btn_snap_description: 'Stuknij, aby otworzyć gotowy post na X. Po prostu dodaj swoje zdjęcie z naszym Lambo i udostępnij, aby wziąć udział w rozdaniu.',
    header: {
      title: 'Wygraj wycieczkę z przyjacielem, której <span class="text-cp">nigdy nie zapomnisz.</span>',
      description: 'W pełni opłacony wyjazd na pierwszy w historii turniej Counter-Strike Major w Kopenhadze w Danii!',
      only_adult: 'Udział mogą wziąć wyłącznie pełnoletni obywatele strefy Schengen.',
      image_description: 'An engaging image of the Lamborghini, highlighting the BitSkins branding, possibly with a user taking a selfie with the car',
    },
    results: {
      title_1: 'Zakwaterowanie w 5-gwiazdkowym hotelu',
      text_1: 'Doświadcz niezrównanego luksusu i komfortu w wykwintnym pięciogwiazdkowym hotelu, idealnym na niezapomniany wypad z przyjacielem.',
      title_2: 'Torby z upominkami premium',
      text_2: 'Gdy przybędziesz do hotelu, będzie na ciebie czekał prezent od nas i naszych partnerów aby umilić wam czas podczas wydarzenia!',
      title_3: 'Zaproszenie na after party z PROs',
      text_3: 'Niezależnie od tego, czy jesteś zagorzałym fanem, czy ciekawskim nowicjuszem, dołącz do nas i przeżyj niezapomniane wrażenia pełne emocji, kameralnej zabawy i niezapomnianych wspomnień.',
    },
    guide: {
      title: 'Nadchodzące wydarzenia w trakcie <span class="text-cp">CS2 Major!</span>',
      show_map: 'zobacz mapę',
      part_title_1: 'Zrób selfie z Lamborghini Huracán EVO - PRINTSTREAM EDITION',
      part_text_1: 'W trakcie trwania Major możesz zrobić sobie selfie z samochodem, który znajdziesz na <span class="text-cp">lotnisku w Kopenhadze</span> oraz podczas weekendu w największej galerii handlowej w Danii: <span class="text-cp">Field\'s (Arne Jacobsens Allé 12, 2300 København, Denmark)</span>.',
      part_title_2: 'Zwiedzaj miasto razem z busem BitSkins',
      part_text_2: 'Dla miłośników komunikacji miejskiej przygotowaliśmy w pełni oklejone autobusy w kolekcji PRINTSTREAM. Linie: <span class="text-cp">31-33-34-35-36</span>, <span class="text-cp">250S-94N</span>, <span class="text-cp">18-32</span>.',
      part_title_3: 'Jeden z najszerszych billboardów w Europie!',
      part_text_3: 'Aby wypromować wydarzenie przygotowaliśmy reklamę na jednym z najszerszych billboardów w Europie. Koniecznie odwiedź: <span class="text-cp">Ågade 114, Copenhagen</span>.',
    },
    plan: {
      title: 'Trzy proste kroki do wielkich zwycięstw!',
      step_1_title: '01. Zrób zdjęcie',
      step_1_text: 'Zrób fajne zdjęcie z naszym markowym Lamborghini na CS2 Major.',
      step_2_title: '02. opublikuj zdjęcie na X',
      step_2_text: 'Opublikuj swoje zdjęcie na X, używając [#YourHashtag] i wspomnij o nas, aby wziąć udział w rozdaniu.',
      step_3_title: '03. Wygraj niesamowite nagrody',
      step_3_text: 'Masz szansę wygrać ekskluzywne skórki CS2 oraz inne fantastyczne nagrody!',
    },
    faq: {
      title: 'Pytania, które możesz mieć teraz:',
      how_enter_giveaway: {
        title: '01. Jak wziąć udział w rozdaniu?',
        answer: 'Po prostu zrób sobie zdjęcie z naszym markowym Lamborghini na CS2 Major i opublikuj je na X z tagiem [#YourHashtag]',
      },
      what_are_the_prizes: {
        title: '02. Jakie są nagrody w rozdaniu?',
        answer: 'Nagroda główna obejmuje skórkę CS2 o wartości 1000 dolarów oraz podpisaną koszulkę gamingową. Dodatkowo, dwóch szczęśliwych zwycięzców otrzyma bonus depozytowy o wartości 100 dolarów na BitSkins.',
      },
      when_winner_announced: {
        title: '03. Kiedy zostaną ogłoszeni zwycięzcy?',
        answer: 'Zwycięzcy zostaną ogłoszeni [konkretna data/godzina] na naszej oficjalnej stronie X i skontaktujemy się z nimi bezpośrednio w celu ustalenia szczegółów odbioru nagrody.',
      },
      are_there_any_restrictions: {
        title: '04. Czy są jakieś ograniczenia dotyczące udziału w rozdaniu?',
        answer: 'Aby wziąć udział w konkursie, uczestnicy muszą być pełnoletni i muszą przestrzegać wszystkich lokalnych przepisów i regulacji dotyczących rozdawania prezentów. Pełny regulamin dostępny jest na naszej stronie internetowej.',
      },
      how_winners_selected: {
        title: '05. W jaki sposób zostaną wybrani zwycięzcy?',
        answer: 'Zwycięzcy zostaną wybrani losowo spośród wszystkich otrzymanych kwalifikujących się zgłoszeń. Proces selekcji jest całkowicie bezstronny i sprawiedliwy dla wszystkich uczestników.',
      },
      can_participate_more_than_once: {
        title: '06. Czy mogę wziąć udział więcej niż raz?',
        answer: 'Tak, możesz wziąć udział wiele razy. Jednak każdy post musi być wyjątkowym zdjęciem z naszym Lamborghini. Zduplikowane posty nie zwiększą Twoich szans na wygraną.',
      },
    },
  },
};
